export default {
  // --- App / global ---
  app_name: 'SwapWish TCG',
  ok: 'OK',
  cancel: 'Annulla',
  save: 'Salva',
  apply: 'Applica',
  back: 'Indietro',
  loading: 'Caricamento',
  error_generic: 'Si è verificato un errore',
  retry: 'Riprova',
  common_close: 'Chiudi',
  common_loading: 'Caricamento',
  common_back: 'Indietro',
  common_search: 'Cerca',
  common_undo: 'Annulla',
  common_clear_search: 'Cancella ricerca',
  common_clear_selection: 'Deseleziona tutto',
  load_more: 'Carica altri',
  collection_load_error: 'Impossibile caricare la collezione. Controlla la connessione e riprova.',
  // Errori di dominio dalle RPC (vedi utils/dbErrorMessages.ts).
  err_tourn_max_active: 'Puoi avere al massimo 5 tornei attivi contemporaneamente.',
  err_tourn_not_verified: 'Solo gli utenti verificati possono creare tornei.',
  err_tourn_past_date: 'La data del torneo non può essere nel passato.',
  err_tourn_own: 'Non puoi iscriverti al tuo torneo.',
  err_tourn_full: 'Numero massimo di partecipanti raggiunto.',
  err_tourn_unavailable: 'Il torneo non è più disponibile.',
  err_tourn_winner_invalid: 'Il vincitore deve essere un partecipante accettato del torneo.',
  err_verify_pending: 'Hai già una richiesta di verifica in attesa.',
  err_verify_already: 'Il tuo profilo è già verificato.',
  err_banner_not_verified: 'Solo gli utenti verificati possono prenotare banner.',
  err_banner_existing: 'Hai già un banner in corso per questa città.',
  err_banner_slot_occupied: 'Slot banner occupato: potrai completare l’acquisto alla scadenza del banner attivo.',
  err_banner_queue_full: 'C’è già un banner approvato in attesa di pagamento per questa città.',
  err_trade_overcommit: 'Alcune quantità non sono più disponibili: aggiorna la selezione e riprova.',
  err_trade_item_locked: 'Uno degli oggetti è impegnato in un altro scambio in attesa.',
  common_decrease_quantity: 'Diminuisci quantità',
  common_increase_quantity: 'Aumenta quantità',
  field_multi_selected_count: '{count} selezionate',
  card_tile_view_prices_aria: 'Vedi prezzi {name}',
  card_tile_edit_aria: 'Modifica {name}',
  card_tile_save_aria: 'Salva modifiche a {name}',
  card_tile_cancel_aria: 'Annulla modifiche a {name}',
  card_tile_quantity_badge: 'Quantità:',
  card_variant_holo: 'Holo',
  card_variant_reverse: 'Reverse',

  // --- Auth ---
  auth_sign_in: 'Accedi',
  auth_sign_up: 'Registrati',
  auth_email: 'Email',
  auth_password: 'Password',
  auth_username: 'Username',
  auth_username_min: 'Username minimo 6 caratteri',
  auth_username_max: 'Username massimo 20 caratteri',
  auth_username_charset: 'Lo username può contenere solo lettere e numeri',
  auth_submit_login: 'Accedi',
  auth_submit_register: 'Registrati',
  auth_tagline: 'Trova carte o prodotti sealed, scambia con chi ti sta vicino.',
  auth_confirm_email: 'Account creato. Controlla la tua email per la conferma, poi accedi. Se non trovi la mail, verifica nello spam.',
  auth_email_in_use: 'Questa email è già registrata. Prova ad accedere, anche con Google se l\'avevi usata in precedenza.',
  auth_error: 'Errore di autenticazione',
  auth_invalid_credentials: 'Credenziali non valide',
  auth_show_password: 'Mostra password',
  auth_hide_password: 'Nascondi password',
  auth_password_min: 'La password deve avere almeno 6 caratteri.',
  auth_password_hint: 'Almeno 8 caratteri, con lettere maiuscole e minuscole.',
  auth_forgot_password: 'Password dimenticata?',
  auth_forgot_title: 'Reimposta la password',
  auth_forgot_subtitle: 'Inserisci l\'email del tuo account: ti invieremo un link per reimpostare la password.',
  auth_forgot_send: 'Invia link di reset',
  auth_reset_need_email: 'Inserisci un\'email valida per reimpostare la password.',
  auth_reset_sent: 'Ti abbiamo inviato un\'email per reimpostare la password. Controlla anche lo spam.',
  auth_reset_title: 'Reimposta la password',
  auth_reset_subtitle: 'Scegli una nuova password per il tuo account.',
  auth_reset_new_password: 'Nuova password',
  auth_reset_confirm_password: 'Ripeti nuova password',
  auth_reset_submit: 'Procedi',
  auth_reset_mismatch: 'Le password non coincidono.',
  auth_reset_expired: 'Link di recupero non valido o scaduto. Richiedi di nuovo il reset.',
  auth_reset_back_login: 'Torna al login',
  auth_or_continue_with: 'oppure continua con',
  auth_google: 'Google',
  auth_first_name: 'Nome',
  auth_last_name: 'Cognome',
  auth_first_name_required: 'Il nome è obbligatorio',
  auth_last_name_required: 'Il cognome è obbligatorio',
  auth_disallowed_words_field: 'Il campo "{field}" contiene parole non ammesse',
  auth_address: 'Indirizzo',
  auth_address_placeholder: 'Cerca via, città, CAP',
  auth_address_hint: 'Utilizzato solo per calcolare distanze approssimative.',
  address_search_label: 'Indirizzo',
  address_search_placeholder: 'Cerca via e numero civico, città…',
  address_search_no_results: 'Indirizzo non trovato: specifica via (ed eventuale civico), non solo la città',
  auth_callback_loading: 'Accesso in corso…',
  auth_callback_redirect_login: 'Reindirizzamento al login…',
  auth_signup_confirmed_title: 'Registrazione completata!',
  auth_signup_confirmed_desc: 'La tua email è stata confermata. Puoi chiudere questa pagina e tornare nell\'app SwapWish TCG per accedere.',

  // --- Tabs ---
  tab_discover: 'Scopri',
  tab_inventory: 'Collezione',
  tab_wishlist: 'Wishlist',
  tab_matches: 'Match',
  tab_profile: 'Profilo',

  // --- Swipe ---
  swipe_set_location_title: 'Imposta la tua posizione',
  swipe_set_location_desc: 'Mostriamo solo distanze approssimative. La tua posizione esatta non viene mai salvata.',
  swipe_enable_geo: 'Abilita geolocalizzazione',
  swipe_searching: 'Cerco abbinamenti vicini a te',
  map_searching: 'Carico abbinamenti sulla mappa',
  map_you: 'Tu',
  map_trade_button: 'Invia proposta',
  map_candidates_title: 'Scambi vicini',
  leaderboard_title: 'Leaderboard scambi',
  leaderboard_short: 'Leaderboard',
  leaderboard_radius_subtitle: 'Migliori utenti trovati nel raggio di {radius} km',
  leaderboard_empty: 'Nessun utente nelle vicinanze.',
  leaderboard_no_rating: 'Nessuna recensione',
  leaderboard_trades: '{count} scambi',
  public_profile_title: 'Profilo utente',
  public_profile_view: 'Vedi profilo',
  last_seen_less_hour: 'Ultimo accesso: meno di un\'ora fa',
  last_seen_one_hour: 'Ultimo accesso: 1 ora fa',
  last_seen_hours: 'Ultimo accesso: {count} ore fa',
  last_seen_one_day: 'Ultimo accesso: 1 giorno fa',
  last_seen_days: 'Ultimo accesso: {count} giorni fa',
  last_seen_weeks: 'Ultimo accesso: settimane fa',
  leaderboard_view_history: 'Storico scambi',
  leaderboard_view_reviews: 'Vedi recensioni',
  leaderboard_inventory: 'Inventario',
  leaderboard_three_way_badge: 'Scambio a tre',
  history_completed_at: 'Completato il {date}',
  leaderboard_history_of: 'Storico di {user}',
  leaderboard_history_empty: 'Nessuno scambio concluso.',
  leaderboard_trade_of: '{a} ⇄ {b}',
  import_title: 'Import massivo inventario',
  import_settings_desc: 'Importa la tua collezione dall\'esterno.',
  import_desc: 'Carica il file esportato (CSV o Excel) dalla piattaforma scelta: le carte vengono aggiunte al tuo inventario. Le righe non riconosciute vengono saltate.',
  import_source: 'Sorgente',
  import_hint_tcgplayer: 'Copertura TCGplayer limitata: le carte senza corrispondenza vengono saltate.',
  import_choose_file: 'Scegli file (CSV/Excel)',
  import_start: 'Importa',
  import_running: 'Importazione…',
  import_error_empty: 'Nessuna riga valida trovata nel file.',
  import_stat_imported: 'Importate',
  import_stat_not_found: 'Non trovate',
  import_stat_errors: 'Errori',
  map_candidates_eyebrow: 'Utenti nel raggio',
  map_candidates_tab_direct: 'Scambi diretti',
  map_candidates_tab_three_way: 'Scambi a tre',
  map_candidates_cards: 'carte',
  map_candidates_products: 'prodotti',
  map_candidates_cards_mine: 'carte tue',
  map_candidates_products_mine: 'prodotti tuoi',
  map_candidates_cards_theirs: 'carte sue',
  map_candidates_products_theirs: 'prodotti suoi',
  map_candidates_trades: 'scambi',
  map_candidate_new_badge: 'Nuovo',
  // Filtro lista candidati (solo scambi diretti)
  map_filter_all: 'Tutti',
  map_filter_compatible: 'Compatibili',
  map_candidate_badge_compatible: 'Compatibile',
  map_candidate_badge_nearby: 'Nelle vicinanze',
  map_candidate_hint_compatible: 'Ha carte della tua wishlist',
  map_candidate_hint_nearby: 'Sfoglia la collezione e proponi',
  // Dialog intermedio di selezione carte (candidato senza abbinamenti)
  candidate_picker_title: 'Scegli i prodotti',
  candidate_picker_subtitle: 'Dalla collezione di {name}',
  candidate_picker_empty: 'Nessun prodotto scambiabile disponibile',
  candidate_picker_games_label: 'Giochi',
  candidate_picker_game_filter_aria: 'Filtra i risultati per {game}',
  candidate_picker_unknown_game: 'Altro gioco',
  candidate_picker_cards_empty: 'Nessuna carta per i giochi selezionati.',
  candidate_picker_sealed_empty: 'Nessun prodotto sealed per i giochi selezionati.',
  map_three_way_cash_badge: 'In denaro',
  map_details_btn: 'Dettagli',
  map_candidate_details_aria: 'Dettagli {name}',
  map_candidates_details_hint: 'Tocca un abbinamento con un utente per vederne i dettagli. Scorri verso sinistra per rimuoverlo dalla mappa.',
  map_three_way_bridge_details_aria: 'Dettagli scambio triplo',
  map_trade_failed: 'Impossibile avviare lo scambio. Riprova.',
  map_trade_three_way_active: 'C\'è già uno scambio a tre attivo con questo utente: completalo o annullalo prima di avviare uno scambio diretto.',
  map_candidate_dismissed: 'Abbinamento rimosso: tornerà visibile solo con nuove carte compatibili.',
  map_pro_expired_banner: 'Il tuo abbonamento Pro è scaduto: gli scambi a tre non vengono più caricati.',
  map_pro_expired_cta: 'Rinnova',
  map_pro_expired_later: 'Più tardi',
  trade_flow_aria: 'Avanzamento della proposta',
  trade_flow_step_create: 'Invia proposta',
  trade_flow_step_quantities: 'Quantità e importo',
  trade_flow_step_send: 'Invia scambio',
  map_three_way_count: '{count} scambi tripli',
  map_three_way_a_to_b: 'Tu dai a {user}',
  map_three_way_b_to_a: '{user} dà a te',
  map_three_way_c_to_b: '{from} dà a {to}',
  map_three_way_b_to_c: '{from} dà a {to}',
  swipe_resolving_location: 'Aggiorno la tua posizione…',
  swipe_empty_title: 'Nessun abbinamento nei dintorni',
  map_candidates_empty_wishlist: 'Nessun abbinamento nei dintorni, aggiungi carte o prodotti sealed nella wishlist per aumentare le possibilità di trovare abbinamenti',
  swipe_empty_desc: 'Non ci sono profili compatibili entro il tuo raggio attuale. Prova ad ampliarlo dal pulsante Filtri o controlla più tardi.',
  swipe_edit_radius: 'Modifica raggio',
  products_filters_button: 'Filtri',
  products_filters_title: 'Filtri prodotti',
  products_filters_any: 'Qualsiasi',
  products_filters_three_way_title: 'Scambi tripli',
  products_filters_three_way_hint: 'Cerca anche scambi a tre in cerchio (A → B → C → A) sulla mappa.',
  products_filters_requested_only_hint: 'I filtri carte e sealed vengono applicati separatamente ai prodotti richiesti dai candidati.',
  products_filters_tcg_multi_help: 'Seleziona un TCG per cercare solo in quel gioco; selezionandone più di uno (o nessuno = tutti) attivi la ricerca di abbinamenti combinati su più TCG.',
  products_filters_tcg_single_help: 'Con Pro puoi selezionare più TCG contemporaneamente e attivare la ricerca di abbinamenti combinati.',
  products_filters_upgrade_pro: 'Attiva abbonamento Pro',
  products_filters_cards_section: 'Carte',
  products_filters_sealed_section: 'Sealed',
  products_filters_condition: 'Condizione carta',
  products_filters_language: 'Lingua',
  products_filters_grading_company: 'Casa gradazione',
  products_filters_grade: 'Voto',
  products_filters_sealed_category: 'Tipo prodotto',
  products_filters_sealed_name: 'Cerca per nome',
  products_filters_sealed_name_placeholder: 'Es. Booster Box Scarlatto e Violetto…',
  swipe_outgoing_match_pending_warning: "Hai match in corso. Gli utenti con cui hai un match attivo non vengono riproposti sulla mappa finché lo scambio non si conclude o non viene eliminato. Dopo l'eliminazione, lo stesso abbinamento torna solo quando uno dei due ha nuovi oggetti compatibili.",
  swipe_free_active_match_cap_warning: 'Raggiunto il numero massimo di 4 match attivi (sblocca l\'abbonamento Pro per match illimitati)',
  swipe_skip: 'Salta',
  swipe_like: 'Mi piace',
  swipe_location_block_title: 'Posizione non disponibile',
  swipe_location_block_desc: 'Geolocalizzazione non attiva o Indirizzo non indicato.',
  swipe_go_to_settings: 'Vai a Impostazioni',
  swipe_slot_block_title: 'Limite slot superato',
  swipe_slot_block_desc: "Limite slot superato, attivare l'abbonamento Pro o ridurre le quantità nell'inventario e nella wishlist.",
  offline_title: 'Connessione non disponibile',
  offline_no_connection: 'Connessione ad Internet assente, impossibile accedere alle funzionalità della piattaforma.',
  mobile_no_internet: 'Connessione ad internet assente',
  mobile_location_unavailable_no_address: 'Geolocalizzazione non attiva e indirizzo predefinito assente nelle impostazioni del profilo',
  mobile_location_using_profile_address: 'Geolocalizzazione non attiva: viene usata la posizione dell\'indirizzo predefinito impostato nel profilo',
  mobile_health_refresh_aria: 'Riesegui verifica',
  mobile_health_dismiss_aria: 'Chiudi avviso',

  // --- Match popup ---
  match_cards_count: '{count} oggetti in comune',
  match_tap_to_view: 'Tocca un\'oggetto per i dettagli',

  // --- Inventory ---
  inv_title: 'Il mio album',
  view_title_inventory: 'Collezione',
  view_title_wishlist: 'Wishlist',
  view_title_catalog: 'Catalogo',
  view_title_matches: 'Match',
  view_title_history: 'Storico',
  view_title_notifications: 'Notifiche',
  inv_slots: '{used}/{total} slot usati',
  inv_slots_unlimited: '{used} slot usati',
  inv_slot_limit_label: 'Limite inventario e wishlist utente',
  inv_free_badge: 'free',
  slot_limit_reached_flash: 'Raggiunto il numero massimo di slot disponibili',
  inv_go_pro: 'Passa a Pro',
  inv_empty_title: 'Il tuo raccoglitore è vuoto',
  inv_empty_desc: 'Tocca il tasto "Aggiungi in inventario" per aggiungere le tue carte/prodotti sealed da proporre in scambio.',
  inv_add: 'Aggiungi',
  inv_add_to_inventory: 'Aggiungi in inventario',
  inv_section_inventory: 'Inventario',
  inv_section_decks: 'Mazzi',
  decks_add_deck: 'Aggiungi mazzo',
  decks_empty_title: 'Nessun mazzo',
  decks_empty_desc: 'Tocca "Aggiungi mazzo" per creare il tuo primo mazzo e aggiungere le carte.',
  decks_slots_label: 'Limite mazzi utente',
  decks_slots_value: '{used} / {limit}',
  decks_slots_unlimited: 'Mazzi illimitati (Pro)',
  decks_limit_reached: 'Hai raggiunto il limite mazzi del piano Free. Passa a Pro per mazzi illimitati.',
  decks_card_count: '{count} carte',
  decks_cards_in_deck: 'Carte nel mazzo',
  decks_deck_value: 'Valore',
  decks_missing_cards: 'Carte mancanti',
  decks_missing_cost: 'Costo',
  deck_rename_title: 'Rinomina mazzo',
  deck_rename_placeholder: 'Nome del mazzo',
  deck_menu_edit: 'Modifica',
  deck_add_to_deck: 'Aggiungi al mazzo',
  deck_menu_delete: 'Elimina',
  deck_delete_confirm_title: 'Eliminare il mazzo?',
  deck_delete_confirm_msg: 'Il mazzo «{name}» e le carte al suo interno verranno eliminati definitivamente.',
  deck_edit_title: 'Modifica mazzo',
  deck_edit_empty: 'Nessuna carta nel mazzo. Usa «Aggiungi al mazzo» per inserirne.',
  deck_to_obtain_badge: 'Carte da ottenere',
  inventory_summary_modal_button: 'Visualizza riepilogo inventario',
  inventory_summary_title: 'Riepilogo inventario',
  inventory_summary_total_cards: 'Carte in collezione',
  inventory_summary_value: 'Valore',
  inventory_summary_graded_cards: 'Carte gradate',
  inventory_summary_ungraded_cards: 'Carte non gradate',
  inventory_summary_game_filter: 'Gioco',
  inventory_summary_all_games: 'Tutti i giochi',
  sealed_summary_total: 'Prodotti sealed',
  sealed_summary_value: 'Valore',
  inv_match_locked_warning: 'Oggetto in un match attivo',
  inv_match_locked_warning_card: 'Carta in un match attivo',
  inv_match_locked_warning_product: 'Prodotto in un match attivo',

  // --- Wishlist ---
  wish_title: 'Wishlist',
  wish_empty_title: 'La tua wishlist è vuota',
  wish_empty_desc: 'Tocca il tasto "Aggiungi in wishlist" per aggiungere le carte/prodotti sealed che stai cercando per trovare abbinamenti sulla mappa.',
  wish_add: 'Aggiungi',
  wish_add_to_wishlist: 'Aggiungi in wishlist',

  // --- Catalog ---
  catalog_search: 'Cerca per nome',
  catalog_results: '{count} risultati',
  catalog_binder: 'Album',
  catalog_wishlist: 'Wishlist',
  catalog_add: 'Aggiungi',
  catalog_added_label: 'Aggiunta',
  catalog_remove: 'Rimuovi',
  catalog_added_binder: '"{name}" aggiunta alla collezione',
  catalog_added_deck: '"{name}" aggiunta al mazzo',
  catalog_added_wish: '"{name}" aggiunta alla wishlist',
  catalog_select_tcg: 'Seleziona TCG',
  search_mode_expansion: 'Espansione',
  search_mode_card: 'Prodotti',
  card_search_placeholder: 'Cerca prodotto',
  card_search_empty: 'Nessun prodotto trovato.',

  // --- Matches / Chat ---
  matches_title: 'I tuoi match',
  matches_empty_title: 'Nessun match effettuato',
  matches_empty_desc: 'Vai nella sezione Scopri per fare un match con altri utenti!',
  matches_section_outgoing: 'Inviati',
  matches_section_incoming: 'In arrivo',
  history_matches_section_outgoing: 'Inviati',
  history_matches_section_incoming: 'Ricevuti',
  matches_unread_label: '{count} messaggi non letti',
  chat_placeholder: 'Scrivi un messaggio…',
  matches_confirm: 'Conferma',
  matches_load_error: 'Impossibile caricare i match. Controlla la connessione e riprova.',
  matches_load_error_title: 'Errore caricamento match',
  matches_load_retry: 'Riprova caricamento',
  matches_deep_link_not_found: 'Questo scambio non è più disponibile.',
  chat_unavailable: 'Impossibile inviare: match non valido o sessione scaduta.',
  chat_attachment_unsupported: 'Formato allegato non supportato.',
  chat_attachment_too_large: 'Il file supera il limite di 5 MB.',
  chat_attachment_too_many: 'Puoi allegare al massimo {count} file per invio.',
  chat_attachment_blocked_nsfw: 'Immagine bloccata: rilevato contenuto esplicito o potenzialmente dannoso.',
  chat_attachment_blocked_text: 'Immagine bloccata: contiene testo non consentito.',
  chat_attachment_checking: 'Verifica immagine…',
  chat_uploading: 'Caricamento allegato…',

  // ── Chat: invio robusto, spunte, typing ──
  chat_send_failed: 'Invio non riuscito',
  chat_retry: 'Riprova',
  chat_delete_failed: 'Elimina',
  chat_sending: 'Invio in corso',
  chat_sent: 'Inviato',
  chat_read: 'Letto',
  chat_new_messages_one: '1 nuovo messaggio',
  chat_new_messages: '{count} nuovi messaggi',
  chat_typing: 'sta scrivendo…',
  chat_typing_named: '{name} sta scrivendo…',
  chat_propose_trade: 'Proponi scambio',
  chat_load_older: 'Carica precedenti',
  chat_attach_aria: 'Allega immagine o video',
  chat_send_aria: 'Invia messaggio',
  chat_remove_attachment_aria: 'Rimuovi allegato',
  chat_lightbox_close_aria: 'Chiudi immagine',

  // --- Notifications ---
  notifications_title: 'Notifiche',
  notifications_empty: 'Nessuna nuova notifica',
  notification_new_match: 'Nuova proposta di scambio.',
  notification_new_message: 'Nuovo messaggio',
  notification_image: 'Immagine',
  notification_trade_proposed: 'Vuole scambiare con te',
  notification_trade_accepted: 'Ha accettato lo scambio: tocca per vedere lo storico e lasciare una recensione',
  notification_trade_cancelled: 'Scambio annullato',
  notification_review_prompt: 'Lascia una recensione sullo scambio appena concluso',
  notification_review_received: 'Hai ricevuto una recensione',
  notification_pro_activated: 'Congratulazioni! Il tuo abbonamento Pro è ora attivo 🎉',
  notifications_view_title: 'Centro notifiche',
  notifications_clear_all: 'Elimina tutte le notifiche',
  notifications_nearby_summary: 'Hai {count} nuovi scambi nelle vicinanze · Visualizza nella sezione Scopri',
  notification_match_deleted: 'Ha eliminato il match con te',
  notification_account_deleted: 'Ha eliminato il proprio account: il match non è più disponibile',
  notifications_push_badge_title: 'Notifiche push disattivate',
  notifications_push_badge_desc: 'Attiva le notifiche push per ricevere subito nuovi match e messaggi.',
  notifications_push_activate: 'Attiva',
  notifications_push_activating: 'Attivazione…',
  notifications_push_enabled: 'Notifiche push attivate.',
  notifications_push_enable_error: 'Impossibile attivare le notifiche push.',
  notifications_unknown_sender: 'Utente non disponibile',

  // --- Reviews ---
  reviews_button: 'Recensioni',
  history_leave_review_btn: 'Recensione',
  reviews_empty: 'Nessuna recensione ancora.',
  reviews_count: '{count} recensioni',
  review_form_title_outgoing: 'Recensisci {user}',
  review_form_title_incoming: 'Recensisci {user}',
  review_form_rating_label: 'Voto',
  review_form_comment_label: 'Commento',
  review_form_comment_placeholder: 'Scrivi un commento (facoltativo)',
  review_comment_not_allowed: 'Il commento contiene parole non consentite',
  review_form_submit: 'Invia',
  review_form_cancel: 'Annulla',
  review_sent: 'Recensione inviata',

  // ── Segnalazione partner di un match ──────────────────────────────────────
  report_button: 'Segnala utente',
  report_already: 'Hai già segnalato questo match',
  report_form_title: 'Segnala {user}',
  report_form_title_three_way: 'Segnala nello scambio a tre',
  report_form_intro: 'Usa la segnalazione solo per un completamento scorretto reale dello scambio. Le segnalazioni infondate riducono la tua affidabilità e la possibilità di segnalare in futuro.',
  report_form_target_label: 'Chi vuoi segnalare?',
  report_target_already: 'Già segnalato',
  trust_badge_trusted: 'Affidabile',
  trust_badge_trusted_desc: 'Scambi completati con ottime recensioni e nessuna segnalazione confermata.',
  trust_badge_flagged: 'Affidabilità bassa',
  trust_badge_flagged_desc: 'Più utenti diversi hanno segnalato problemi nel completamento degli scambi.',
  report_form_reason_label: 'Motivo',
  report_reason_no_show: 'Non si è presentato',
  report_reason_item_not_as_described: 'Carta diversa da quanto pattuito',
  report_reason_incomplete_trade: 'Scambio interrotto a metà',
  report_reason_abusive_behavior: 'Comportamento offensivo',
  report_reason_other: 'Altro',
  report_form_comment_label: 'Dettagli (facoltativo)',
  report_form_comment_placeholder: 'Descrivi cosa è successo…',
  report_form_ack: 'Confermo che la segnalazione è veritiera e in buona fede.',
  report_form_submit: 'Invia segnalazione',
  report_form_cancel: 'Annulla',
  report_comment_not_allowed: 'Il commento contiene parole non consentite',
  report_rate_limited: 'Hai raggiunto il limite di segnalazioni recenti. Riprova più avanti.',
  report_submit_error: 'Impossibile inviare la segnalazione. Riprova.',

  // --- Profile ---
  profile_title: 'Profilo',
  profile_bio: 'Bio',
  profile_save: 'Salva profilo',
  profile_saved: 'Profilo aggiornato',
  profile_social_title: 'Link social pubblici',
  profile_social_edit: 'Modifica profilo {social}',
  profile_social_confirm: 'Conferma link social',
  profile_social_invalid: 'Inserisci un link valido per Facebook, Instagram o eBay',
  profile_settings: 'Impostazioni',
  profile_help: 'Guida',
  profile_location: 'Posizione',
  profile_donate_paypal: 'Dona con Paypal ❤️',
  profile_invite_friend: 'Invita un amico',

  // --- Referral / Invita un amico ---
  auth_referral_code_optional: 'Codice invito (facoltativo)',
  auth_referral_code_hint: 'Hai ricevuto un codice da un amico? Inseriscilo qui.',
  invite_title: 'Invita un amico',
  invite_back_label: 'Torna indietro',
  invite_eyebrow: 'Porta un amico su SwapWish',
  invite_heading: 'Invita un amico, ottieni 7 giorni Pro',
  invite_description: 'Condividi il tuo codice. Quando il tuo amico scarica l\'app, si registra, entra nel gruppo Telegram e raggiunge il suo primo match attivo, ricevi 7 giorni di abbonamento Pro.',
  invite_your_code: 'Il tuo codice',
  invite_share: 'Condividi invito',
  invite_share_message: 'Unisciti a me su SwapWish TCG e scambiamo carte! Usa il mio codice invito:',
  invite_copied_toast: 'Invito copiato negli appunti',
  invite_share_unsupported: 'Condivisione non disponibile su questo dispositivo',
  invite_list_title: 'I tuoi inviti',
  invite_loading: 'Caricamento…',
  invite_empty: 'Non hai ancora invitato nessuno.',
  invite_pending_friend: 'Amico invitato',
  invite_community_title: 'Community Telegram',
  invite_community_desc: 'Entra nel gruppo ufficiale: serve anche per convalidare gli inviti.',
  invite_community_join: 'Unisciti alla community',
  invite_community_open: 'Apri / completa l\'ingresso',
  invite_community_joined: 'Sei nel gruppo',
  invite_status_pending: 'In attesa',
  invite_status_registered: 'Registrato',
  invite_status_joined_telegram: 'Nel gruppo Telegram',
  invite_status_qualified: 'Idoneo',
  invite_status_rewarded: 'Premio ottenuto',
  invite_status_rejected: 'Non valido',
  profile_privacy: 'Norme sulla privacy',
  profile_legal_section: 'Extra',
  profile_child_safety: 'Sicurezza dei minori',
  profile_terms: 'Termini di servizio',
  profile_app_version: 'Versione app',

  // --- Privacy policy ---
  privacy_title: 'Norme sulla privacy',
  privacy_intro: 'SwapWish TCG è un\'app per scambiare carte e prodotti sealed da gioco con persone vicine a te. Questa pagina spiega quali dati trattiamo, perché e con quali servizi, in conformità al Regolamento (UE) 2016/679 (GDPR).',
  privacy_last_update: 'Ultimo aggiornamento: 10 giugno 2026',
  privacy_owner_title: 'Titolare del trattamento',
  privacy_owner_desc: 'Il titolare del trattamento è il team SwapWish TCG, contattabile all\'indirizzo support@swapwishtcg.com. Per qualsiasi richiesta relativa ai tuoi dati puoi scriverci in ogni momento.',
  privacy_data_title: 'Dati che raccogliamo',
  privacy_data_desc: 'Trattiamo solo i dati necessari al funzionamento dell\'app:',
  privacy_data_account_title: 'Account',
  privacy_data_account_desc: 'email, username, nome e cognome, password (conservata in forma cifrata dal nostro provider di autenticazione) ed eventuale avatar caricato.',
  privacy_data_location_title: 'Posizione',
  privacy_data_location_desc: 'coordinate GPS (se autorizzi la geolocalizzazione) oppure l\'indirizzo che inserisci, usati solo per calcolare distanze approssimate dagli altri utenti.',
  privacy_data_collection_title: 'Collezione e wishlist',
  privacy_data_collection_desc: 'le carte e i prodotti sealed che dichiari di possedere o cercare, con condizione, lingua, eventuale gradazione e prezzo indicativo.',
  privacy_data_trades_title: 'Match, scambi e chat',
  privacy_data_trades_desc: 'i match generati, le proposte di scambio, gli scambi conclusi, le recensioni, le segnalazioni e i messaggi (testo e media) scambiati in chat con gli altri utenti.',
  privacy_data_push_title: 'Notifiche push',
  privacy_data_push_desc: 'il token del dispositivo necessario a recapitare le notifiche (nuovi match, proposte, scambi accettati), se le abiliti.',
  privacy_data_payments_title: 'Abbonamento e donazioni',
  privacy_data_payments_desc: 'lo stato dell\'abbonamento Pro e l\'esito dei pagamenti. I dati di pagamento (carta, conto) sono gestiti esclusivamente da PayPal o dagli store mobile e non transitano mai sui nostri sistemi.',
  privacy_location_title: 'Geolocalizzazione',
  privacy_location_desc: 'La posizione serve unicamente a mostrare candidati di scambio nel raggio scelto e distanze approssimate sulla mappa. La tua posizione esatta non viene mai mostrata agli altri utenti: i marker sono volutamente approssimati.',
  privacy_location_note: 'Puoi revocare il permesso di geolocalizzazione in qualsiasi momento dalle impostazioni del dispositivo: in tal caso l\'app userà solo l\'indirizzo eventualmente indicato nelle impostazioni del profilo.',
  privacy_purpose_title: 'Finalità del trattamento',
  privacy_purpose_matching_title: 'Matching geografico',
  privacy_purpose_matching_desc: 'incrociare collezione e wishlist degli utenti nel raggio impostato per proporre scambi compatibili.',
  privacy_purpose_trades_title: 'Gestione degli scambi',
  privacy_purpose_trades_desc: 'creare e tracciare match, proposte, scambi a tre, storico e recensioni.',
  privacy_purpose_notifications_title: 'Notifiche',
  privacy_purpose_notifications_desc: 'avvisarti di nuovi match, proposte ricevute, scambi accettati e messaggi.',
  privacy_purpose_support_title: 'Assistenza e sicurezza',
  privacy_purpose_support_desc: 'rispondere alle richieste di supporto e prevenire abusi della piattaforma.',
  privacy_third_title: 'Servizi di terze parti',
  privacy_third_desc: 'Per funzionare l\'app si appoggia a servizi esterni selezionati:',
  privacy_third_supabase_title: 'Supabase',
  privacy_third_supabase_desc: 'autenticazione, database e archiviazione (inclusi avatar e media delle chat), su infrastruttura nell\'Unione Europea.',
  privacy_third_firebase_title: 'Google Firebase',
  privacy_third_firebase_desc: 'recapito delle notifiche push tramite Firebase Cloud Messaging (riceve solo il token del dispositivo).',
  privacy_third_paypal_title: 'PayPal e store mobile',
  privacy_third_paypal_desc: 'donazioni tramite PayPal e abbonamenti Pro tramite Google Play: i dati di pagamento restano presso PayPal/Google secondo le rispettive privacy policy.',
  privacy_third_catalogs_title: 'Cataloghi e prezzi TCG',
  privacy_third_catalogs_desc: 'CardTrader, TCGdex, pokemontcg.io, Scryfall, YGOPRODeck ed eBay forniscono catalogo e prezzi di mercato dei prodotti: a questi servizi non viene inviato alcun tuo dato personale.',
  privacy_third_maps_title: 'OpenStreetMap',
  privacy_third_maps_desc: 'tile della mappa nella sezione Scopri; le richieste delle mappe contengono solo l\'area visualizzata.',
  privacy_push_title: 'Notifiche push',
  privacy_push_desc: 'Le notifiche sono opzionali: puoi disattivarle dalle impostazioni del dispositivo o dell\'app. Disattivandole il token del dispositivo non viene più utilizzato.',
  privacy_security_title: 'Sicurezza e conservazione',
  privacy_security_desc: 'I dati viaggiano cifrati (TLS) e l\'accesso al database è protetto da politiche di sicurezza a livello di riga: ogni utente può accedere solo ai propri dati e a quelli strettamente necessari agli scambi (es. collezioni pubbliche dei candidati).',
  privacy_retention_desc: 'I dati sono conservati finché il tuo account è attivo. Alla cancellazione dell\'account vengono rimossi i dati personali; possono essere conservati in forma aggregata o anonima i dati statistici sugli scambi.',
  privacy_rights_title: 'I tuoi diritti (GDPR)',
  privacy_rights_desc: 'In ogni momento puoi esercitare i diritti previsti dagli artt. 15-22 del GDPR:',
  privacy_rights_access_title: 'Accesso e portabilità',
  privacy_rights_access_desc: 'ottenere copia dei dati che ti riguardano in un formato leggibile.',
  privacy_rights_rectify_title: 'Rettifica',
  privacy_rights_rectify_desc: 'correggere i dati del profilo direttamente dall\'app (Profilo e Impostazioni) o tramite supporto.',
  privacy_rights_delete_title: 'Cancellazione',
  privacy_rights_delete_desc: 'richiedere l\'eliminazione dell\'account e dei dati associati scrivendo al supporto.',
  privacy_rights_withdraw_title: 'Revoca dei consensi',
  privacy_rights_withdraw_desc: 'revocare geolocalizzazione e notifiche dalle impostazioni del dispositivo, senza pregiudicare i trattamenti già effettuati.',
  privacy_minors_title: 'Minori',
  privacy_minors_desc: 'L\'app non è destinata a minori di 14 anni. Se ritieni che un minore ci abbia fornito dati personali, contattaci e provvederemo alla rimozione.',
  privacy_contact_title: 'Contatti',
  privacy_contact_desc: 'Per domande su queste norme o per esercitare i tuoi diritti scrivi a support@swapwishtcg.com oppure usa la sezione Supporto dell\'app.',
  privacy_changes_note: 'Eventuali modifiche a queste norme saranno pubblicate su questa pagina con la data di aggiornamento. Le modifiche sostanziali saranno segnalate nell\'app.',

  // --- Cancellazione account (URL pubblico richiesto da Google Play) ---
  del_title: 'Eliminazione dell\'account',
  del_intro: 'Questa pagina spiega come eliminare il tuo account SwapWish TCG e tutti i dati associati. Puoi farlo direttamente dall\'app oppure inviando una richiesta via email.',
  del_last_update: 'Ultimo aggiornamento: 10 giugno 2026',
  del_app_title: 'Eliminare l\'account dall\'app',
  del_app_desc: 'Il modo più rapido è dall\'app, dove l\'eliminazione è immediata e definitiva:',
  del_app_step1: 'Apri l\'app e accedi al tuo account.',
  del_app_step2: 'Vai su Profilo → Impostazioni.',
  del_app_step3: 'In fondo alla pagina tocca "Elimina account".',
  del_app_step4: 'Conferma: l\'account e tutti i dati vengono rimossi e l\'eventuale abbonamento Pro viene annullato.',
  del_app_note: 'L\'operazione è irreversibile: una volta confermata non è possibile recuperare account o dati.',
  del_email_title: 'Richiesta via email',
  del_email_desc: 'Se non riesci ad accedere all\'app puoi richiedere l\'eliminazione scrivendo dall\'indirizzo email associato al tuo account a:',
  del_email_note: 'Indica l\'email del tuo account. Daremo seguito alla richiesta entro 30 giorni, previa verifica dell\'identità.',
  del_data_title: 'Dati che vengono eliminati',
  del_data_desc: 'Con la cancellazione dell\'account rimuoviamo definitivamente:',
  del_data_account: 'i dati dell\'account: email, username, nome e cognome, password e avatar;',
  del_data_collection: 'la tua collezione e la tua wishlist;',
  del_data_trades: 'match, proposte di scambio, scambi conclusi e recensioni;',
  del_data_messages: 'i messaggi e i media scambiati nelle chat;',
  del_data_location: 'la posizione e l\'indirizzo salvati;',
  del_data_subscription: 'i dati dell\'abbonamento (l\'abbonamento Pro attivo viene annullato presso lo store);',
  del_data_files: 'i file caricati (avatar e allegati delle chat).',
  del_retained_title: 'Dati conservati e tempistiche',
  del_retained_desc: 'I dati personali vengono eliminati immediatamente con la cancellazione dall\'app, o entro 30 giorni per le richieste via email. Possono essere conservati esclusivamente dati statistici in forma aggregata o anonima, non riconducibili alla tua identità, ed eventuali registri richiesti dalla legge (es. ricevute di pagamento) per il periodo previsto dalla normativa.',
  del_timing_desc: 'I dati di pagamento non sono mai conservati sui nostri sistemi: sono gestiti da PayPal e dagli store mobile secondo le rispettive policy.',

  // --- Standard di sicurezza dei minori (URL pubblico CSAE richiesto da Google Play) ---
  cs_title: 'Standard di sicurezza dei minori',
  cs_intro: 'SwapWish TCG applica una politica di tolleranza zero verso l\'abuso e lo sfruttamento sessuale di minori (CSAE). Questi standard, pubblicati in conformità alle norme sulla sicurezza dei minori di Google Play, descrivono ciò che è vietato, come segnalare e come interveniamo.',
  cs_last_update: 'Ultimo aggiornamento: 10 giugno 2026',
  cs_prohibited_title: 'Divieto assoluto di CSAE',
  cs_prohibited_desc: 'È severamente vietato usare SwapWish TCG per qualsiasi contenuto o condotta legati all\'abuso o allo sfruttamento sessuale di minori, inclusi:',
  cs_prohibited_csam: 'materiale di abuso sessuale su minori (CSAM) in qualsiasi forma, anche generato o alterato digitalmente;',
  cs_prohibited_grooming: 'adescamento di minori (grooming): qualsiasi contatto volto ad abusare o sfruttare un minore;',
  cs_prohibited_sextortion: 'sextortion: minacce o ricatti a sfondo sessuale ai danni di minori;',
  cs_prohibited_sexualization: 'qualsiasi forma di sessualizzazione di minori, inclusi testi, immagini o richieste nelle chat.',
  cs_age_title: 'Età minima',
  cs_age_desc: 'L\'app non è destinata a minori di 14 anni. Gli account riconducibili a utenti sotto l\'età minima vengono rimossi. Se ritieni che un minore stia usando la piattaforma, segnalacelo.',
  cs_report_title: 'Come segnalare',
  cs_report_desc: 'Puoi segnalare contenuti o comportamenti sospetti direttamente dall\'app, da Impostazioni → Assistenza, oppure scrivendo al punto di contatto dedicato:',
  cs_report_note: 'Le segnalazioni relative alla sicurezza dei minori vengono esaminate con priorità assoluta. In caso di pericolo immediato contatta prima le forze dell\'ordine (112).',
  cs_actions_title: 'Come interveniamo',
  cs_actions_desc: 'Quando una violazione di questi standard viene accertata:',
  cs_actions_remove: 'il contenuto viene rimosso immediatamente;',
  cs_actions_ban: 'l\'account responsabile viene chiuso in modo permanente;',
  cs_actions_authorities: 'il caso viene segnalato alle autorità competenti (in Italia la Polizia Postale e, ove applicabile, il NCMEC);',
  cs_actions_preserve: 'le prove vengono conservate nei limiti di legge per supportare le indagini.',
  cs_law_title: 'Conformità alle leggi',
  cs_law_desc: 'SwapWish TCG rispetta le leggi applicabili in materia di tutela dei minori, incluse le normative italiane ed europee e i relativi obblighi di segnalazione, oltre agli standard sulla sicurezza dei minori di Google Play.',
  cs_contact_title: 'Punto di contatto designato',
  cs_contact_desc: 'Il punto di contatto designato per la sicurezza dei minori, preparato a gestire le comunicazioni in materia di CSAE, è raggiungibile all\'indirizzo support@swapwishtcg.com.',

  // --- Termini di servizio (rotta pubblica /terms) ---
  tos_title: 'Termini di servizio',
  tos_intro: 'Questi termini regolano l\'uso di SwapWish TCG. Creando un account o usando l\'app li accetti integralmente: leggili con attenzione.',
  tos_last_update: 'Ultimo aggiornamento: 10 giugno 2026',
  tos_service_title: 'Il servizio',
  tos_service_desc: 'SwapWish TCG è una piattaforma che mette in contatto collezionisti di carte e prodotti sealed da gioco per scambi di persona, incrociando collezione, wishlist e posizione degli utenti.',
  tos_service_note: 'L\'app non è parte degli scambi: non vende prodotti, non gestisce pagamenti tra utenti e non fa da intermediario o garante delle transazioni.',
  tos_account_title: 'Account',
  tos_account_desc: 'Per usare l\'app devi avere almeno 14 anni e fornire dati veritieri. Sei responsabile della custodia delle credenziali e di tutto ciò che avviene tramite il tuo account. È consentito un solo account per persona.',
  tos_conduct_title: 'Regole di condotta',
  tos_conduct_desc: 'Usando la piattaforma ti impegni a NON:',
  tos_conduct_fraud: 'commettere frodi, truffe o proporre scambi che non intendi onorare;',
  tos_conduct_fakes: 'offrire carte o prodotti contraffatti, alterati o di provenienza illecita;',
  tos_conduct_offensive: 'pubblicare contenuti illeciti, offensivi, molesti o discriminatori, in chat o nel profilo;',
  tos_conduct_commercial: 'usare l\'app per attività commerciali non autorizzate o spam;',
  tos_conduct_abuse: 'manipolare il sistema (account multipli, bot, scraping, recensioni false o segnalazioni pretestuose verso altri utenti).',
  tos_trades_title: 'Scambi tra utenti',
  tos_trades_desc: 'Gli scambi avvengono direttamente tra utenti, che ne sono gli unici responsabili:',
  tos_trades_verify: 'verifica di persona autenticità e condizioni dei prodotti prima di concludere lo scambio;',
  tos_trades_meet: 'scegli luoghi pubblici e frequentati per gli incontri;',
  tos_trades_reviews: 'lascia recensioni oneste: aiutano la community a scambiare in sicurezza;',
  tos_trades_no_warranty: 'SwapWish non garantisce esito, qualità o valore degli scambi; i prezzi mostrati sono stime di mercato indicative.',
  tos_pro_title: 'Abbonamento Pro',
  tos_pro_desc: 'L\'abbonamento Pro è fatturato tramite Google Play e si rinnova automaticamente fino a disdetta, da effettuare in Google Play → Pagamenti e abbonamenti. Eliminando l\'account, l\'abbonamento attivo viene annullato. Prezzi e contenuti dell\'offerta possono variare con ragionevole preavviso.',
  tos_ip_title: 'Contenuti e proprietà intellettuale',
  tos_ip_desc: 'Resti titolare dei contenuti che carichi (avatar, foto, messaggi) e concedi a SwapWish la licenza necessaria a mostrarli nell\'app. Nomi, loghi e immagini dei giochi di carte appartengono ai rispettivi titolari: SwapWish TCG non è affiliata, sponsorizzata o approvata da alcun editore di TCG.',
  tos_ip_note: 'I dati di catalogo e i prezzi provengono da fornitori terzi e sono offerti senza garanzia di completezza o accuratezza.',
  tos_liability_title: 'Responsabilità e chiusura dell\'account',
  tos_liability_desc: 'Il servizio è fornito "così com\'è", senza garanzie di disponibilità continua o assenza di errori. Nei limiti di legge, SwapWish non risponde dei danni derivanti dagli scambi tra utenti, da indisponibilità del servizio o da inesattezze di catalogo e prezzi.',
  tos_termination_desc: 'Puoi eliminare il tuo account in qualsiasi momento da Impostazioni o dalla pagina di eliminazione account. In caso di violazione di questi termini possiamo sospendere o chiudere l\'account, anche senza preavviso nei casi gravi.',
  tos_law_title: 'Legge applicabile e contatti',
  tos_law_desc: 'Questi termini sono regolati dalla legge italiana; per le controversie con i consumatori è competente il foro di residenza dell\'utente. Per qualsiasi domanda scrivi a support@swapwishtcg.com.',
  tos_changes_note: 'Eventuali modifiche a questi termini saranno pubblicate su questa pagina con la data di aggiornamento. Le modifiche sostanziali saranno segnalate nell\'app.',
  profile_logout: 'Esci',
  profile_info_section: 'Informazioni profilo',
  profile_other_section: 'Altro',
  profile_change_photo: 'Cambia foto',
  profile_avatar_alt: 'Avatar profilo',
  profile_edit_username: 'Modifica username',
  profile_save_username: 'Salva username',
  profile_cancel_username: 'Annulla',
  profile_username_not_allowed: 'Lo username contiene parole non consentite',
  profile_share: 'Condividi profilo',
  profile_share_message: 'Guarda il mio inventario e la mia wishlist su SwapWish TCG!',
  profile_share_copied: 'Link copiato negli appunti',
  profile_share_error: 'Condivisione non riuscita',
  shared_profile_loading: 'Caricamento…',
  shared_profile_not_found_title: 'Profilo non disponibile',
  shared_profile_not_found_desc: 'Questo link di condivisione non è più valido.',
  shared_profile_inventory: 'Inventario cedibile',
  shared_profile_wishlist: 'Wishlist',
  shared_profile_empty_inventory: 'Nessuna carta cedibile.',
  shared_profile_empty_wishlist: 'Nessuna carta in wishlist.',
  shared_profile_cta: 'Scopri SwapWish TCG',
  profile_username_taken: 'Questo username è già in uso',

  // --- Help ---
  // ── Popup introduttivi per vista (primo utilizzo) ────────────────────────
  intro_eyebrow: 'Guida rapida',
  intro_got_it: 'Ricevuto!',
  intro_discover_title: 'Scopri',
  intro_discover_bullets: [
    'La mappa mostra i collezionisti nel tuo raggio: i pallini indigo sono gli abbinamenti (scambi reciproci o chi ha un oggetto che cerchi), i pallini viola più chiari sono gli altri utenti vicini con almeno una carta.',
    'Tocca un abbinamento per vedere cosa scambiare e avviare il Match. Su un utente senza abbinamenti scegli tu le carte da richiedere: le aggiungiamo temporaneamente alla tua Wishlist e imposti quantità e importo negli Scambi (le carte escono dalla Wishlist a scambio concluso o eliminato).',
    'Nel dettaglio tocca il nome dell’utente per aprire il profilo con Collezione, Wishlist, storico e recensioni; negli scambi senza carte in cambio proponi un corrispettivo in denaro.',
    'Il pulsante Lista apre le sezioni Tutti / Compatibili e, con Pro, Scambi a tre come terza sezione (di default Tutti); il pulsante 👑 apre la Leaderboard scambi. Dai Filtri regoli il raggio (fino a 25 km Free, 500 km Pro) e scegli il TCG: serve la posizione attiva o un indirizzo salvato, e la posizione esatta resta privata.',
    '🔒 Pro: filtri per condizione, lingua e grading, abbinamenti combinati selezionando più TCG nei Filtri (anche per proporre carte di giochi diversi), scambi tripli A → B → C → A e notifiche push per i nuovi candidati nel raggio.',
  ],
  intro_inventory_title: 'Collezione',
  intro_inventory_bullets: [
    'È il tuo raccoglitore digitale: le espansioni sono raggruppate con il numero di carte e prodotti sealed.',
    "Tocca un'espansione per aggiungere carte con condizione, lingua, quantità, grading e variante — anche via scansione, ricerca per nome o import massivo (Impostazioni).",
    'Gli oggetti impegnati in un Match attivo restano bloccati e non possono essere modificati o riutilizzati finché il Match non viene risolto.',
    'Col selettore Inventario/Mazzi crei i tuoi mazzi (3 gratis, illimitati con Pro); il riepilogo mostra quantità e valore della Collezione.',
  ],
  intro_wishlist_title: 'Wishlist',
  intro_wishlist_bullets: [
    'Aggiungi le carte e i prodotti sealed che cerchi: è ciò che il sistema usa per trovarti i match.',
    'Più è precisa (condizione, lingua, variante), più gli abbinamenti sono pertinenti.',
    'Quando una proposta viene accettata, le quantità scambiate vengono aggiornate automaticamente; modificala manualmente per acquisti o scambi fatti fuori dall’app.',
  ],
  intro_matches_title: 'Match',
  intro_matches_bullets: [
    'Match inviati, in arrivo e scambi tripli hanno tab separati; una proposta tripla ricevuta resta accessibile anche ai partecipanti Free.',
    'Sulla mappa, “Invia proposta” salva la bozza dello scambio triplo: apri Dettagli e inviala dalla tab Scambi tripli.',
    'Tocca la riga per accordarti in chat (anche con foto), oppure accordati di persona; solo dopo usa Dettagli per scegliere oggetti e quantità e inviare o accettare la proposta.',
    'Gli oggetti di una proposta in attesa restano riservati.',
    'Gli scambi completati vanno nello Storico, dove puoi lasciare una recensione.',
  ],
  intro_detailsModal_title: 'Dettaglio scambio',
  intro_detailsModal_bullets: [
    'A sinistra le carte che offri, a destra quelle che ricevi.',
    'Usa i selettori +/- per scegliere quante copie scambiare.',
    'Sotto il Totale di ogni colonna puoi aggiungere un importo in denaro (€), utile quando una parte mette solo denaro.',
    'Usa Invia scambio o Accetta scambio accanto alla chiusura; dopo l’azione, tocca il badge In attesa per riaprire il dettaglio in sola lettura.',
  ],
  intro_profile_title: 'Profilo',
  intro_profile_bullets: [
    'Modifica username, avatar e link social pubblici; puoi anche condividere Collezione cedibile e Wishlist con un link.',
    'Da Impostazioni gestisci gioco predefinito, indirizzo, import massivo e, su mobile, notifiche e abbonamento Pro.',
    'Qui consulti le recensioni ricevute e apri Guida e Contatti; lo Storico scambi si apre dall’icona orologio nella scheda Match.',
  ],
  intro_catalog_title: 'Catalogo',
  intro_catalog_bullets: [
    'Sfoglia tutte le espansioni del gioco, con carte, prodotti sealed e numero carta sui tile.',
    "Cerca un'espansione per nome o passa a Prodotti per una singola carta. Per Pokémon le espansioni sono divise in Occidentale e Orientale.",
    "Apri un'espansione per aggiungere prodotti a inventario o wishlist, con i prezzi di mercato.",
  ],

  // ── Tour guidato (sostituisce i popup "Guida rapida" automatici) ──────────
  tour_progress: 'Passo {current} di {total}',
  tour_next: 'Avanti',
  tour_back: 'Indietro',
  tour_skip: 'Salta il tour',
  tour_finish: 'Fine',
  tour_welcome_eyebrow: 'Il Team di SwapWish',
  tour_welcome_title: 'Benvenuto in SwapWish!',
  tour_welcome_message: 'Sei pronto: la mappa è il tuo punto di partenza per scoprire collezionisti vicini e iniziare a scambiare.',
  // Frase con badge "Guida" cliccabile (→ vista Guida in Impostazioni): before +
  // <badge> + after, così il badge è un elemento interattivo dentro al testo.
  tour_welcome_guide_before: 'Dal Profilo, con il pulsante',
  tour_welcome_guide_after: 'trovi una spiegazione dettagliata della piattaforma. Buoni scambi!',

  tour_discover_intro_title: 'Scopri chi scambia vicino a te',
  tour_discover_intro_text: 'La mappa mostra i collezionisti compatibili nel tuo raggio. La tua posizione esatta resta privata: si usa un punto approssimato di circa 1 km.',
  tour_discover_map_title: 'La mappa dei candidati',
  tour_discover_map_text: 'Ogni pallino è un collezionista con cui puoi scambiare: toccalo per vedere cosa offre e avviare un Match.',
  tour_discover_filters_title: 'Raggio e filtri',
  tour_discover_filters_text: 'Da qui regoli il raggio (fino a 25 km nel piano Free, 500 km con Pro) e scegli il TCG in cui cercare. Con Pro sblocchi filtri per condizione, lingua e grading e gli abbinamenti combinati su più TCG.',
  tour_discover_candidates_title: 'Lista candidati',
  tour_discover_candidates_text: 'Preferisci un elenco alla mappa? Qui trovi tutti i candidati vicini, con il badge dei nuovi arrivati.',
  tour_discover_leaderboard_title: 'Leaderboard scambi',
  tour_discover_leaderboard_text: 'La corona apre la classifica dei collezionisti più attivi nelle vicinanze per scambi e recensioni.',
  tour_discover_tournaments_title: 'Tornei vicino a te',
  tour_discover_tournaments_text: 'I profili verificati organizzano tornei: li riconosci dal pallino giallo sulla mappa e dal pulsante Tornei, con la lista degli eventi nel tuo raggio.',
  tour_discover_to_inventory_title: 'La tua Collezione',
  tour_discover_to_inventory_text: 'Passiamo alla Collezione: il tuo raccoglitore digitale di carte e prodotti sealed.',

  tour_inventory_intro_title: 'Il tuo raccoglitore digitale',
  tour_inventory_intro_text: 'Qui le espansioni sono raggruppate con il numero di carte e prodotti sealed che possiedi.',
  tour_inventory_scan_title: 'Aggiungi con la fotocamera',
  tour_inventory_scan_text: 'Inquadra una carta per riconoscerla e aggiungerla al volo, senza cercarla a mano.',
  tour_inventory_add_title: 'Aggiungi manualmente',
  tour_inventory_add_text: 'Inserisci carte e sealed scegliendo condizione, lingua, quantità, grading e variante.',
  tour_inventory_filters_title: 'Cerca e filtra',
  tour_inventory_filters_text: "Trova in fretta un'espansione o una carta e passa tra Inventario e Mazzi.",
  tour_inventory_summary_title: 'Riepilogo Collezione',
  tour_inventory_summary_text: 'Consulta quantità e valore stimato. Gli oggetti impegnati in un Match attivo restano bloccati finché non si risolve.',
  tour_inventory_to_wishlist_title: 'La tua Wishlist',
  tour_inventory_to_wishlist_text: 'Vediamo ora la Wishlist: le carte e i prodotti che stai cercando.',

  tour_wishlist_intro_title: 'Ciò che cerchi',
  tour_wishlist_intro_text: 'Aggiungi le carte e i sealed che desideri: è la base che il sistema usa per trovarti i match.',
  tour_wishlist_add_title: 'Aggiungi alla Wishlist',
  tour_wishlist_add_text: 'Più sei preciso su condizione, lingua e variante, più gli abbinamenti saranno pertinenti.',
  tour_wishlist_filters_title: 'Cerca e filtra',
  tour_wishlist_filters_text: "A proposta accettata le quantità si aggiornano da sole; puoi modificarle a mano per acquisti fatti fuori dall'app.",

  tour_catalog_intro_title: 'Il Catalogo del gioco',
  tour_catalog_intro_text: 'Sfoglia tutte le espansioni con carte, prodotti sealed e prezzi di mercato.',
  tour_catalog_search_title: 'Cerca nel catalogo',
  tour_catalog_search_text: "Trova un'espansione per nome o passa a Prodotti per cercare una singola carta.",
  tour_catalog_grid_title: "Apri un'espansione",
  tour_catalog_grid_text: 'Da qui aggiungi i prodotti alla tua Collezione o alla Wishlist, con i prezzi aggiornati.',
  tour_catalog_to_matches_title: 'I tuoi Match',
  tour_catalog_to_matches_text: 'Andiamo ai Match: dove nascono e si gestiscono gli scambi.',

  tour_matches_intro_title: 'Gestisci i tuoi scambi',
  tour_matches_intro_text: 'Match inviati, in arrivo e scambi tripli sono organizzati in schede separate.',
  tour_matches_tabs_title: 'Le schede dei Match',
  tour_matches_tabs_text: 'Apri Dettagli per scegliere oggetti e quantità e inviare o accettare; tocca la riga per la chat. Gli oggetti in attesa restano riservati.',
  tour_matches_history_title: 'Storico e recensioni',
  tour_matches_history_text: 'Gli scambi completati finiscono qui, dove puoi lasciare una recensione al tuo partner.',
  tour_matches_to_profile_title: 'Il tuo Profilo',
  tour_matches_to_profile_text: 'Ultima tappa: il Profilo e le sue impostazioni.',

  tour_profile_intro_title: 'Il tuo Profilo',
  tour_profile_intro_text: 'Personalizza username, avatar e link social, e condividi Collezione cedibile e Wishlist con un link.',
  tour_profile_settings_title: 'Impostazioni',
  tour_profile_settings_text: 'Gestisci gioco predefinito, indirizzo, import massivo e, su mobile, notifiche e abbonamento Pro.',
  tour_profile_help_title: 'Guida e supporto',
  tour_profile_help_text: 'Qui trovi sempre questa guida, le recensioni ricevute e i contatti per ogni dubbio.',

  // Badge funzioni Pro nel tooltip del tour.
  tour_pro_badge: 'Pro',
  // Sezioni descritte dal pulsante d'ingresso (il tour non entra nelle viste,
  // che possono essere vuote): il testo spiega cosa mostrerà la sezione al click.
  tour_nav_inventory_title: 'La tua Collezione',
  tour_nav_inventory_text: 'Collezione apre il tuo raccoglitore digitale: le carte e i prodotti sealed che possiedi e vuoi cedere in scambio.',
  tour_nav_wishlist_title: 'La tua Wishlist',
  tour_nav_wishlist_text: 'Wishlist apre ciò che cerchi: le carte e i sealed che desideri. È la base che il sistema usa per trovarti gli abbinamenti sulla mappa.',
  tour_nav_matches_title: 'I tuoi Match',
  tour_nav_matches_text: 'Match apre i tuoi scambi: proposte inviate e in arrivo, scambi a tre (Pro) e la chat per accordarti. Nello storico trovi gli scambi conclusi e le recensioni.',
  tour_nav_profile_title: 'Il tuo Profilo',
  tour_nav_profile_text: 'Profilo apre le impostazioni (gioco predefinito, indirizzo, abbonamento), la condivisione di Collezione e Wishlist con un link e questa guida.',

  help_hero_desc: 'La piattaforma pensata per collezionisti di carte TCG che vogliono scambiare in modo sicuro, diretto e senza complicazioni.',
  help_in_person_title: 'Perché scambiare di persona?',
  help_in_person_desc: 'Le spedizioni portano rischi reali: carte o prodotti sealed danneggiati in transito, smarrimenti, truffe difficili da contestare. SwapWish nasce proprio per eliminarli.',
  help_in_person_transport_title: 'Zero rischi di trasporto',
  help_in_person_transport_desc: 'vedi le carte o i prodotti sealed dal vivo prima dello scambio, nessuna sorpresa.',
  help_in_person_direct_title: 'Scambio diretto tra collezionisti',
  help_in_person_direct_desc: 'nessun intermediario, nessuna piattaforma di pagamento, nessuna commissione.',
  help_in_person_mutual_title: 'Match utili (anche con corrispettivo)',
  help_in_person_mutual_desc: "un match appare quando avete entrambi qualcosa da guadagnare, oppure quando l'altro ha una carta che cerchi: in quest'ultimo caso puoi proporre uno scambio con un corrispettivo in denaro.",
  help_in_person_events_title: 'Ideale per fiere ed eventi',
  help_in_person_events_desc: "con Pro puoi allargare il raggio per trovare collezionisti lontani con cui accordarti prima dell'evento.",
  help_sections_title: "Le sezioni dell'app",
  help_section_discover_desc: 'Visualizza sulla mappa i collezionisti compatibili nel tuo raggio.',
  help_section_discover_b1: 'Tocca un cerchio per vedere cosa scambiare e avviare il Match.',
  help_section_discover_b2: 'Dal dettaglio, tocca il nome utente per aprire il profilo: Collezione, Wishlist, storico e recensioni.',
  help_section_discover_b3: 'Il pulsante Lista elenca tutti i candidati vicini.',
  help_section_discover_b4: 'La corona apre la Leaderboard degli utenti vicini con scambi conclusi.',
  help_section_discover_b5: 'Filtri regola raggio e TCG in cui cercare; con Pro sblocca condizione, lingua e grading dei prodotti, gli abbinamenti combinati selezionando più TCG e gli scambi tripli.',
  help_section_discover_b6: "Alcuni abbinamenti (diretti o tripli) prevedono un corrispettivo in denaro impostato prima dell'invio; il pagamento avviene di persona, fuori dall'app.",
  help_section_inventory_desc: 'Il tuo raccoglitore digitale.',
  help_section_inventory_b1: 'Aggiungi carte o prodotti sealed da scambiare con condizione, lingua, quantità, grading e variante.',
  help_section_inventory_b2: 'Aggiungili sfogliando il catalogo, cercandoli per nome o con la scansione live da fotocamera.',
  help_section_inventory_b3: 'Ogni tile mostra numero carta e prezzi di mercato.',
  help_section_inventory_b4: 'Gli oggetti impegnati in un Match attivo non si possono modificare o riutilizzare finché il Match non è risolto.',
  help_section_inventory_b5: 'Dal selettore Inventario/Mazzi crei mazzi privati (3 gratis, illimitati con Pro), che non influiscono sugli scambi.',
  help_section_wishlist_desc: 'I prodotti che cerchi sono la base degli abbinamenti sulla mappa.',
  help_section_wishlist_b1: 'Più la Wishlist è precisa (condizione minima accettata, lingua, variante), più gli abbinamenti sono pertinenti.',
  help_section_wishlist_b2: 'Quando una proposta viene accettata, le quantità scambiate si aggiornano automaticamente.',
  help_section_wishlist_b3: "Intervieni manualmente solo per variazioni avvenute fuori dall'app.",
  help_section_matches_desc: 'Qui trovi i Match creati (Inviati), quelli ricevuti (In arrivo) e gli scambi tripli.',
  help_section_matches_b1: '«Invia proposta» sulla mappa salva una bozza tripla: apri Dettagli nella tab Scambi tripli, completala e inviala da lì.',
  help_section_matches_b2: 'Ricerca e creazione richiedono Pro; i partecipanti Free possono aprire e rispondere alle proposte ricevute.',
  help_section_matches_b3: 'Tocca una riga per la chat; dopo esservi accordati in chat o di persona, usa Dettagli per selezionare prodotti e quantità, poi Invia scambio o Accetta scambio accanto alla chiusura. Il badge In attesa riapre il dettaglio in sola lettura.',
  help_section_matches_b4: 'Gli oggetti proposti restano riservati finché lo scambio non è risolto.',
  help_section_matches_b5: "L'accettazione aggiorna Collezione e Wishlist e sposta lo scambio nello Storico (icona orologio).",
  help_section_matches_b6: "Se previsto, il corrispettivo in denaro si imposta prima dell'invio e si paga di persona, fuori dall'app.",
  help_section_profile_desc: 'Personalizza il tuo profilo pubblico e accedi alle impostazioni.',
  help_section_profile_b1: 'Modifica username, avatar e link social pubblici.',
  help_section_profile_b2: 'Condividi Collezione cedibile e Wishlist tramite link.',
  help_section_profile_b3: 'Consulta le recensioni ricevute.',
  help_section_profile_b4: 'Apri Impostazioni: gioco predefinito, indirizzo, import da CardTrader/Cardmarket/TCGplayer, notifiche mobile Pro e abbonamento.',
  help_section_profile_b5: 'Accedi a Guida e Contatti.',
  help_section_profile_b6: 'Lo Storico degli scambi completati si apre invece dalla scheda Match.',
  help_section_catalog_desc: 'Si apre aggiungendo prodotti da Collezione o Wishlist.',
  help_section_catalog_b1: 'Contiene tutte le espansioni di ogni gioco con carte e sealed e i prezzi di mercato.',
  help_section_catalog_b2: 'Per Pokémon, sezioni separate Occidentale/Orientale.',
  help_section_catalog_b3: "Cerca un'espansione per nome o una singola carta in tutto il gioco con la ricerca Prodotti.",
  help_swipe_title: 'Come funziona la mappa',
  help_swipe_desc: 'La sezione Scopri non mostra utenti a caso: applica automaticamente criteri di compatibilità e posiziona sulla mappa solo profili con uno scambio possibile.',
  help_swipe_mutual_title: 'Compatibilità e corrispettivo',
  help_swipe_mutual_desc: "vengono incrociati la tua wishlist con l'inventario degli altri e, in parallelo, la loro wishlist con il tuo inventario. Compaiono i profili utili a entrambi e anche chi ha una carta della tua wishlist pur non cercando nulla dal tuo inventario: in quel caso lo scambio si può regolare con un corrispettivo in denaro indicato nel dettaglio.",
  help_swipe_radius_title: 'Raggio geografico',
  help_swipe_radius_desc: 'vedi solo profili entro il tuo raggio, regolabile dal pulsante Filtri nella scheda Scopri: fino a 25 km nel piano Free, fino a 500 km con Pro.',
  help_swipe_pro_filters_title: 'Filtri Pro',
  help_swipe_pro_filters_desc: 'puoi restringere gli abbinamenti per condizione, lingua, casa di gradazione e voto. I filtri vengono salvati sul dispositivo e applicati alla ricerca successiva.',
  help_swipe_identity_title: 'Criteri di identità carta',
  help_swipe_identity_desc: 'il sistema tiene conto di carta, condizione, lingua, grading e variante per garantire la pertinenza degli abbinamenti.',
  help_swipe_dismiss_title: 'Rimuovere un abbinamento',
  help_swipe_dismiss_desc: 'nella lista dei candidati trascina un abbinamento verso sinistra per eliminarlo: non verrà più proposto finché uno dei due utenti non avrà almeno una carta nuova rispetto al risultato precedente.',
  help_map_filter_title: 'Tutti / Compatibili / Scambi a tre',
  help_map_filter_desc: 'in cima alla lista scegli "Compatibili" per vedere solo gli utenti con cui hai già un abbinamento, oppure "Tutti" per includere anche gli altri utenti vicini con almeno una carta. Con Pro, "Scambi a tre" è la terza sezione e raccoglie i cicli utili tra tre persone.',
  help_map_compose_title: 'Proporre a chi non ha abbinamenti',
  help_map_compose_desc: 'toccando un utente senza abbinamenti scegli tu le carte dalla sua collezione (anche di giochi diversi se sei Pro con più giochi nel filtro); confermi quantità e importo o extra in denaro nella scheda Scambi.',
  help_map_wishlist_autoadd_title: 'Carte aggiunte alla wishlist',
  help_map_wishlist_autoadd_desc: 'le carte che scegli vengono aggiunte automaticamente alla tua wishlist per gestire lo scambio, e rimosse quando lo scambio si conclude o viene eliminato.',
  help_match_title: 'Come funziona un Match',
  help_match_positive_title: 'Match positivo',
  help_match_positive_desc: 'tocca Scambia nel dettaglio di un candidato compatibile: il nuovo Match compare nella sezione Inviati.',
  help_match_chat_title: 'Chat',
  help_match_chat_desc: 'tocca la riga del match e accordatevi su quanti e quali oggetti scambiare, dove e quando incontrarvi.',
  help_match_proposal_title: 'Proposta formale',
  help_match_proposal_desc: "dopo esservi accordati in chat o di persona, apri Dettagli: chi avvia usa Invia scambio e chi riceve usa Accetta scambio, entrambi accanto alla chiusura del modale. Dopo l'azione, il badge In attesa riapre la proposta in sola lettura.",
  help_match_in_person_title: 'Scambio di persona',
  help_match_in_person_desc: 'vi incontrate, scambiate le carte/prodotti sealed a mano e il match viene chiuso.',
  help_match_delete_title: 'Eliminare un match',
  help_match_delete_desc: 'se elimini un match, la ricerca non riproporrà lo stesso abbinamento: tornerà visibile solo quando uno dei due utenti avrà qualcosa di nuovo di compatibile che non era incluso nel risultato precedente.',
  help_match_note: "Le carte o i prodotti sealed inclusi in una proposta in attesa risultano bloccati e non possono essere selezionati in altri match finché quella proposta non viene risolta. Inoltre, finché hai un match attivo con un utente, quell'utente non compare tra i candidati sulla mappa: torna visibile solo quando lo scambio si conclude o viene eliminato.",
  help_pro_title: 'Perché diventare Pro?',
  help_pro_desc: 'SwapWish Pro sblocca funzionalità avanzate pensate per chi scambia con frequenza, su distanze maggiori o con più giochi.',
  help_pro_radius_title: 'Raggio fino a 500 km',
  help_pro_radius_desc: 'perfetto per eventi, fiere e convention fuori zona. Nel piano Free il limite è 25 km.',
  help_pro_slots_title: 'Slot Collezione e Wishlist illimitati',
  help_pro_slots_desc: 'il piano Free condivide 25 slot, conteggiati per quantità, tra Collezione e Wishlist; con Pro il limite viene rimosso.',
  help_pro_three_way_title: 'Scambi a tre (A → B → C → A)',
  help_pro_three_way_desc: 'sulla mappa trovi scambi in cerchio tra tre utenti: tu dai a B, B dà a C e C dà a te. Sono mostrati i cicli completi e i ponti in denaro che aggiungono un vantaggio reale; se B e C sono già entrambi candidati diretti e tu dovresti pagare B, il ciclo viene escluso perché basta uno scambio diretto con denaro, anche insieme a carte o prodotti. Tocca lo scambio per vedere ogni passaggio. Poi crei la bozza (1/3), scegli quantità e importo in Match (2/3) e invii la proposta (3/3). Finché è attiva, i partecipanti non compaiono tra gli scambi diretti.',
  help_pro_filters_title: 'Filtri avanzati in Scopri',
  help_pro_filters_desc: 'restringi la ricerca per condizione, lingua, casa di gradazione e voto direttamente dal pulsante Filtri.',
  help_pro_multi_tcg_title: 'Ricerca multi-TCG',
  help_pro_multi_tcg_desc: 'seleziona più TCG dal pulsante Filtri per estendere la ricerca a più giochi contemporaneamente, anche al di fuori del gioco predefinito.',
  help_pro_visibility_title: 'Maggiore visibilità',
  help_pro_visibility_desc: 'il tuo profilo viene prioritizzato nell’elenco dei candidati compatibili e mostra il badge Pro.',
  help_pro_nearby_title: 'Alert scambio vicino in tempo reale',
  help_pro_nearby_desc: 'Ogni 5 minuti SwapWish cerca nuovi candidati compatibili entro il raggio impostato. Se ne compare uno nuovo, anche ad app chiusa, ricevi una sola notifica push che apre la sezione Scopri, da cui puoi avviare il Match. I candidati già noti non generano notifiche ripetute e gli utenti Free che hanno raggiunto il limite di 4 Match attivi vengono esclusi. Funziona nell’app mobile e richiede posizione in background e notifiche push abilitate.',
  help_report_title: 'Segnalazioni e affidabilità',
  help_report_desc: 'Dalla chat di uno scambio attivo puoi segnalare un partner che non porta a termine correttamente lo scambio. Lo strumento è pensato per essere utile ma difficile da abusare.',
  help_report_how_title: 'Come segnalare',
  help_report_how_desc: "tocca l'icona bandierina in alto a destra nella chat e scegli un motivo (mancata presentazione, carta diversa dal pattuito, scambio interrotto, comportamento offensivo). Negli scambi a tre puoi scegliere quale dei due partecipanti segnalare, o entrambi.",
  help_report_limit_title: 'Una per utente, con un limite',
  help_report_limit_desc: 'puoi inviare una sola segnalazione per ciascun utente in quello scambio e solo un numero ridotto di segnalazioni in pochi giorni: segnalare ha un costo, così lo spam non conviene.',
  help_report_weight_title: 'Conta il pattern, non il singolo voto',
  help_report_weight_desc: "una singola segnalazione non penalizza nessuno. Il sistema interviene solo quando più utenti diversi segnalano la stessa persona, dando più peso alle segnalazioni di chi ha buona reputazione e meno a chi segnala di continuo.",
  help_report_privacy_title: 'Riservatezza',
  help_report_privacy_desc: "le segnalazioni sono confidenziali: l'utente segnalato non sa chi l'ha segnalato, così non sono possibili ritorsioni.",
  help_report_badge_title: 'Badge di affidabilità',
  help_report_badge_desc: "sul profilo e nelle recensioni può comparire un badge: “Affidabile” per chi ha ottime recensioni e nessuna segnalazione confermata, oppure “Affidabilità bassa” solo quando più utenti diversi hanno segnalato problemi.",
  help_support_title: 'Serve aiuto?',
  help_support_desc: "Per problemi, segnalazioni o suggerimenti usa Contatti nel Profilo oppure scrivi a {email}: rispondiamo il prima possibile.",

  // --- Nearby trade alerts ---
  nearby_alert_title: 'Scambio vicino disponibile',
  nearby_alert_subtitle: '{user} a {distance} km · Visualizza i dettagli nella sezione Scopri',
  nearby_alert_section_title: 'Vicino a te',
  nearby_alert_claim_cta: 'Avvia scambio',
  nearby_alert_claim_error_already_claimed: 'Un altro utente ha già avviato questo scambio.',
  nearby_alert_claim_error_free_cap: 'Il limite di scambi attivi del piano Free è stato raggiunto per la controparte.',
  nearby_alert_push_title: 'Scambio vicino disponibile',
  nearby_alert_push_body: 'Visualizza i dettagli nella sezione Scopri.',
  bg_geo_title: 'SwapWish',
  bg_geo_notice: 'Manteniamo aggiornata la tua posizione approssimativa per gli abbinamenti.',

  // --- Settings ---
  settings_title: 'Impostazioni',
  settings_language: 'Lingua',
  settings_language_it: 'Italiano',
  settings_language_en: 'English',
  settings_radius: 'Raggio di scambio',
  settings_radius_desc: 'Mostriamo solo carte entro {radius} km da te.',
  settings_radius_free: 'Il piano Free è limitato a 25 km.',
  settings_go_pro: 'Passa a SwapWish Pro',
  settings_pro_desc: 'Raggio fino a 500 km, slot illimitati e scambi tripli e tanto altro.',
  settings_three_way: 'Scambi tripli',
  settings_three_way_desc: 'Suggerimenti di scambi a tre in cerchio (A → B → C → A) per chiudere stalli.',
  settings_pro_only: '(solo Pro)',
  settings_update_loc: 'Aggiorna posizione',
  settings_update_loc_desc: 'La tua posizione esatta non viene salvata, solo una approssimazione.',

  // --- Subscription ---
  sub_title: 'SwapWish Pro',
  sub_price: '1,99',
  sub_period: '/mese',
  sub_subtitle: 'Sblocca ricerca avanzata, più raggio e strumenti per scambiare con precisione.',
  sub_already_pro: 'Sei già un utente Pro!',
  sub_activated_button: 'Abbonamento attivato',
  sub_pay_app_store: 'Abbonati con Apple App Store',
  sub_pay_app_store_loading: 'Apertura App Store',
  sub_pay_play_store: 'Abbonati con Google Play',
  sub_pay_play_store_loading: 'Apertura Google Play',
  sub_mobile_only_message: "L'acquisto Pro è disponibile solo da app mobile (iOS/Android) tramite store.",
  sub_store_redirected_notice: 'Ti stiamo reindirizzando allo store per completare il pagamento.',
  sub_store_error: 'Impossibile avviare il pagamento sullo store. Riprova.',
  sub_play_billing_unavailable: 'Il pagamento Google Play non è disponibile in questa versione dell’app. Aggiorna l’app dal Play Store e riprova.',
  sub_verify_access_denied: 'Google Play non è configurato per verificare questo acquisto. Riprova più tardi o contatta l’assistenza.',
  sub_verify_purchase_pending: 'Google Play non ha ancora reso disponibile l’acquisto per la verifica. Chiudi e riapri l’app tra qualche secondo: l’abbonamento verrà completato automaticamente.',
  sub_verify_error: 'Non è stato possibile verificare l’acquisto con Google Play. Riprova più tardi.',
  sub_legal: 'Sottoscrivendo accetti i Termini di servizio. Puoi cancellare in qualsiasi momento dalle impostazioni del tuo store.',
  sub_renewal_notice: 'Abbonamento Pro mensile con rinnovo automatico ogni mese salvo annullamento prima del rinnovo.',
  sub_features: [
    'Raggio fino a 500 km',
    'Alert scambio vicino in tempo reale (entro il tuo raggio di ricerca)',
    'Slot inventario e wishlist illimitati',
    'Mazzi illimitati',
    'Filtri avanzati in Scopri: condizione, lingua, gradazione e voto',
    'Ricerca abbinamenti combinati su più TCG',
    'Suggerimenti scambi a tre in cerchio (A → B → C → A)',
    'Badge profilo Pro',
  ],

  // --- Three-way trades ---
  three_title: 'Scambi tripli',
  three_pro_gate_title: 'Funzione Pro',
  three_pro_gate_desc: 'I suggerimenti di scambi a tre in cerchio (A → B → C → A) sono disponibili solo per gli utenti Pro e vengono mostrati nella mappa.',
  three_intro: 'Scambio in cerchio: <strong>tu</strong> dai una carta a <strong>B</strong>, <strong>B</strong> ne dà una a <strong>C</strong> e <strong>C</strong> ne dà una a <strong>te</strong>.',
  three_empty_title: 'Nessuno scambio a tre trovato',
  three_empty_desc: 'Al momento non ci sono scambi a tre nel tuo raggio. Aggiungi più carte alla wishlist e al binder per aumentare le chance!',
  three_propose: 'Proponi questo scambio',
  three_proposed: 'Scambio triplo proposto!',
  three_create_match: 'Invia proposta',
  three_way_match_created: 'Bozza creata (1/3). Ora scegli quantità e importo (2/3), poi invia la proposta (3/3).',
  three_you: 'Tu',
  three_distances: 'Distanze: {d1}km + {d2}km',

  // --- Card condition ---
  cond_mint: 'M',
  cond_near_mint: 'NM',
  cond_excellent: 'EX',
  cond_good: 'GD',
  cond_light_played: 'LP',
  cond_played: 'PL',
  cond_poor: 'PO',

  // --- Barra filtri (Collezione / Wishlist) ---
  filter_name_placeholder: 'Nome carta',
  filter_card_placeholder: 'Cerca carta',
  filter_sealed_placeholder: 'Cerca prodotto',
  filter_number_placeholder: '#  Numero',
  filter_expansion_placeholder: 'Espansione',
  filter_product_type_placeholder: 'Categoria',
  filter_results: '{count} di {total}',
  filter_no_results: 'Nessuna carta corrisponde alla ricerca',

  // --- Categorie prodotti sealed ---
  sealed_category_booster_pack: 'Booster Pack',
  sealed_category_booster_box: 'Booster Box',
  sealed_category_elite_trainer_box: 'Elite Trainer Box',
  sealed_category_collection_box: 'Collection Box',
  sealed_category_deck: 'Mazzo',
  sealed_category_tin: 'Tin',
  sealed_category_bundle: 'Bundle',
  sealed_category_case: 'Case',
  sealed_category_accessory: 'Accessorio',
  sealed_category_other: 'Altro',

  // --- Foglio modifica raggio (Scopri) ---
  swipe_radius_title: 'Raggio di ricerca',
  swipe_radius_loading: 'Applicazione raggio e caricamento nuovi match…',

  // --- Impostazioni: aggiorna indirizzo ---
  settings_update_address_desc: 'Modifica la posizione usata per calcolare le distanze.',
  settings_address_saved: 'Indirizzo aggiornato',
  settings_current_address_label: 'Indirizzo salvato',
  settings_current_address_none: 'Nessun indirizzo salvato',

  // --- Indirizzo predefinito obbligatorio ---
  address_required_title: 'Indirizzo predefinito richiesto',
  address_required_message: "Per usare SwapWish devi indicare un indirizzo predefinito nelle Impostazioni: è la posizione usata per trovare abbinamenti nelle vicinanze quando il GPS è spento o non sei online. Né l'indirizzo né la posizione GPS vengono mai resi pubblici: agli altri utenti viene mostrata solo una posizione approssimativa di circa 1 km.",
  address_required_cta: 'Vai alle Impostazioni',
  settings_address_required_banner: "Indica un indirizzo predefinito per continuare. Non verrà reso pubblico: sulla mappa viene usata solo una posizione approssimativa di circa 1 km.",

  // --- Impostazioni: gioco predefinito ---
  settings_default_game: 'Gioco predefinito',
  settings_default_game_desc: 'Pre-seleziona il filtro gioco.',
  settings_default_game_none: 'Tutti i giochi',
  settings_default_game_save_error: 'Impossibile salvare il gioco predefinito. Riprova.',

  // --- Onboarding ---
  onboarding_game_title: 'Scegli il tuo gioco',
  onboarding_game_info: 'Potrai cambiare il gioco predefinito in qualsiasi momento dalle Impostazioni.',
  onboarding_game_save_error: 'Impossibile salvare il gioco nel tuo profilo. Controlla la connessione e riprova.',
  onboarding_skip: 'Salta',
  onboarding_next: 'Avanti',
  onboarding_start: 'Inizia',
  onboarding_dialog_aria: 'Tutorial di benvenuto',
  onboarding_slide_aria: 'Slide {current} di {total}',
  onboarding_slide1_title: 'Scambia di persona',
  onboarding_slide1_desc: 'SwapWish mette in contatto collezionisti di carte TCG nella tua zona. Niente spedizioni, niente rischi: trovi chi ha le tue carte, vi accordate e vi incontrate di persona.',
  onboarding_slide2_title: 'La tua Collezione',
  onboarding_slide2_desc: 'Nella scheda Collezione aggiungi carte o prodotti sealed da scambiare. Gli oggetti impegnati in un Match attivo vengono bloccati finché il Match non viene risolto; puoi anche creare fino a 3 mazzi gratis.',
  onboarding_slide3_title: 'La tua Wishlist',
  onboarding_slide3_desc: 'Aggiungi in Wishlist le carte o i prodotti sealed che cerchi. Il sistema propone sia scambi reciproci, sia utenti che hanno ciò che cerchi ma non desiderano nulla dalla tua Collezione: in quel caso puoi offrire un corrispettivo in denaro.',
  onboarding_slide4_title: 'Match e accordati',
  onboarding_slide4_desc: 'Quando tocchi Scambia su un profilo compatibile nasce il Match. Vai nella scheda Match, chatta per accordarti e scambiate gli oggetti di persona - sicuro e senza intermediari.',
  onboarding_slide5_title: 'Trova collezionisti vicini',
  onboarding_slide5_desc: 'Attiva la posizione o salva un indirizzo nelle Impostazioni per trovare collezionisti compatibili. Il raggio si regola dal pulsante Filtri in Scopri: fino a 25 km con il piano Free, fino a 500 km con Pro. La posizione esatta non viene mai salvata.',

  // --- Swipe stamps ---
  stamp_like: 'MATCH',
  stamp_nope: 'SWIPE',
  stamp_in_wishlist: 'Nella tua wishlist',

  // --- Location source ---
  location_source_gps: 'GPS attivo',
  location_source_address: 'Posizione da indirizzo profilo',
  settings_address_geo_hint: "L'indirizzo non è pubblico: viene usata una posizione approssimativa. Il GPS del dispositivo ha sempre la priorità.",

  // --- Catalog: condition selector ---
  catalog_condition_label: 'Condizione',
  catalog_language_label: 'Lingua',
  catalog_grading_company_label: 'Gradazione',
  catalog_grading_company_none: 'Nessuna',
  catalog_grade_label: 'Voto',
  catalog_grade_placeholder: 'Seleziona',
  catalog_price_label: 'Prezzo',
  catalog_notes_label: 'Note',
  catalog_notes_placeholder: 'Indicare eventuali voti sub',
  catalog_notes_placeholder_extra: 'Indicare info extra (stamped, sealed ecc)',
  deck_builder_title: 'Crea mazzi',

  matches_delete: 'Elimina',
  matches_send_trade: 'Invia scambio',
  matches_waiting_acceptance: 'In attesa',
  matches_waiting_details_button: 'In attesa — apri i dettagli dello scambio',
  matches_accept_trade: 'Accetta scambio',

  // --- Support ---
  profile_contacts: 'Contatti',
  donate_title: 'Dona con Paypal',
  donate_back_label: 'Torna al profilo',
  donate_eyebrow: 'Grazie per il supporto',
  donate_heading: 'Sostieni SwapWish',
  donate_description:
    'Se SwapWish ti sta aiutando a trovare scambi migliori, puoi supportare lo sviluppo con una donazione PayPal.',
  donate_account_label: 'Account PayPal',
  donate_paypal_button: 'Apri PayPal',
  donate_paypal_button_aria: 'Apri PayPal in una nuova finestra',
  donate_paypal_item_name: 'Donazione SwapWish TCG',
  donate_paypal_note: 'Verrai reindirizzato a PayPal per completare la donazione in sicurezza.',
  contacts_title: 'Contatti',
  contacts_email_section: 'Contattaci',
  contacts_email_hint: 'Scrivici per assistenza, segnalazioni o suggerimenti.',
  contacts_email_copied: 'Indirizzo email copiato',
  contacts_social_section: 'Social',
  contacts_telegram: 'Community Telegram',
  contacts_instagram: 'Instagram',

  // --- Match notifications ---
  matches_trade_sent: 'Proposta inviata!',
  matches_trade_accepted: 'Scambio accettato!',
  matches_match_deleted: 'Match eliminato',
  matches_section_three_way: 'Scambi tripli',
  matches_three_way_empty_title: 'Nessuno scambio triplo',
  matches_three_way_empty_desc: 'Quando proponi o ricevi uno scambio a tre, lo trovi qui.',
  matches_three_way_proposal_title: 'Proposta scambio triplo',
  matches_three_way_role_proposer: 'Hai proposto tu',
  matches_three_way_role_participant: 'In attesa della tua risposta',
  matches_three_way_accepted: 'Scambio triplo accettato!',
  matches_three_way_declined: 'Proposta rifiutata.',
  matches_three_way_detail_button: 'Dettaglio',
  matches_three_way_leg_a_to_b: '{a} dà a {b}',
  matches_three_way_leg_b_to_a: '{b} dà a {a}',
  matches_three_way_leg_c_to_b: '{c} dà a {b}',
  matches_three_way_leg_b_to_c: '{b} dà a {c}',
  matches_three_way_leg_c_to_a: '{c} dà a {a}',
  // Etichette delle 3 sezioni dello scambio a tre, dal punto di vista di chi
  // guarda il modale (my_role). Sezioni: ab = A→B, bc = B→C, ca = C→A.
  matches_three_way_sec_proposer_ab: 'Tu dai a {b}',
  matches_three_way_sec_proposer_bc: '{b} dà a {c}',
  matches_three_way_sec_proposer_ca: 'Tu ricevi da {c}',
  matches_three_way_sec_b_ab: 'Ricevi da {a}',
  matches_three_way_sec_b_bc: 'Tu dai a {c}',
  matches_three_way_sec_b_ca: '{c} dà a {a}',
  matches_three_way_sec_c_ab: '{a} dà a {b}',
  matches_three_way_sec_c_bc: 'Tu ricevi da {b}',
  matches_three_way_sec_c_ca: 'Tu dai a {a}',
  matches_three_way_role_a: '{user} (propone)',
  matches_three_way_role_b: '{user}',
  matches_three_way_role_c: '{user}',
  matches_three_way_you_suffix: '(tu)',
  matches_three_way_status_pending: 'In attesa',
  matches_three_way_status_accepted: 'Accettato',
  matches_three_way_status_declined: 'Rifiutato',
  matches_three_way_role_participant_waiting: 'In attesa che gli altri partecipanti accettino',
  matches_three_way_unknown_user: 'Utente sconosciuto',
  matches_three_way_leg_min_one: 'Ogni passaggio deve avere almeno un oggetto',
  matches_three_way_cash_required: 'Imposta l\'importo in denaro prima di inviare lo scambio',
  three_way_review_title: 'Valuta i partecipanti',
  three_way_review_hint: 'Lascia una valutazione per ciascun altro partecipante allo scambio triplo.',
  three_way_review_all_done: 'Hai già valutato questo scambio.',
  history_section_three_way: 'Scambi tripli',
  history_three_way_empty_title: 'Nessuno scambio triplo concluso',
  history_three_way_empty_desc: 'Gli scambi a tre completati appariranno qui.',
  history_three_way_proposal_title: 'Scambio triplo',
  details_unavailable_section: 'Già proposti in un altro match',
  details_available_section: 'Oggetti disponibili',
  details_total: 'Totale',
  details_cash: 'Importo',
  details_cash_pending: 'Importo in denaro',
  details_cash_extra: 'Extra',
  details_trade_requirement_badge: 'Per inviare lo scambio, completa la colonna indicando un importo/extra oppure selezionando almeno una carta o un prodotto sealed.',
  details_peer_item_required_badge: 'Il match deve includere carte o prodotti sealed: selezionane almeno uno con quantità maggiore di zero. L’importo/extra può essere aggiunto, ma non li sostituisce.',
  details_column_required: 'Seleziona almeno una carta/prodotto sealed o indica un importo nella colonna di {user}',
  details_unavailable_committed_badge: 'Gli oggetti non disponibili sono già impegnati in un altro match.',
  details_conflict_accept_blocked: 'Uno o più oggetti proposti sono già impegnati in un altro scambio in attesa: per accettare, prima concludi o elimina l\'altro scambio.',
  details_traded_section: 'Oggetti scambiate',
  details_not_traded_section: 'Oggetti non scambiabili',
  matches_details_validation_loading: 'Verifica disponibilità oggetti…',
  matches_trade_block_my_inventory: 'Una o più oggetti che stai offrendo sono già impegnati in un\'altra proposta in attesa: non hai abbastanza copie disponibili.',
  matches_trade_block_peer_inventory: 'L\'altro utente sta già offrendo una degli oggetti richiesti in un\'altra proposta in attesa. Riprova più tardi.',
  matches_trade_block_initiator_inventory: 'L\'utente che ti ha inviato la proposta non ha più copie sufficienti: ha già impegnato l\'oggetto in un\'altra proposta in attesa.',
  matches_trade_block_wishlist: 'Hai già un\'altra proposta in attesa che ti consegna questo oggetto: accettare supererebbe la quantità in wishlist.',
  matches_trade_block_no_valid_cards: 'Non puoi inviare la proposta: non ci sono quantità valide disponibili negli oggetti selezionabili.',
  matches_trade_insufficient_my_inventory: 'Non hai abbastanza copie disponibili di uno o più oggetti che stai offrendo.',
  matches_trade_insufficient_initiator_inventory: 'L\'utente che ti ha inviato la proposta non ha più copie sufficienti di uno o più oggetti.',
  matches_trade_insufficient_wishlist: 'La quantità nella tua wishlist per uno o più oggetti non è sufficiente per accettare questo scambio.',
  matches_no_available_cards: 'Non ci sono oggetti disponibili',
  matches_chat_hint_outgoing_items: [
    'Tocca il match per aprire la chat e accordarti, oppure accordati di persona.',
    'Dopo l’accordo usa Dettagli per scegliere carte e quantità e inviare la proposta.',
    'In attesa riapre il dettaglio in sola lettura.',
    'Scorri verso sinistra da qualsiasi punto della riga per eliminare il match.',
  ],
  matches_chat_hint_incoming: 'Tocca il match per aprire la chat e accordarti, oppure accordati di persona. Dopo l’accordo usa Dettagli per consultare e accettare la proposta. Scorri verso sinistra da qualsiasi punto della riga per eliminare il match.',
  matches_chat_button: 'Chat',
  matches_details_button: 'Dettagli',
  matches_row_menu: 'Azioni match',

  // --- Pro tier / Multi-TCG / History ---
  profile_pro_status_active: 'Abbonamento Pro attivo',
  profile_go_pro_badge: 'Diventa Pro',
  settings_pro_membership_title: 'Abbonamento Pro',
  settings_pro_expiry_value: 'Scadenza: {date}',
  settings_pro_expiry_unknown: 'Data non disponibile',
  settings_pro_cancel_btn: 'Annulla abbonamento',
  settings_pro_cancel_scheduled: 'Annullamento già pianificato a fine periodo.',
  settings_pro_cancel_confirm_title: 'Conferma annullamento',
  settings_pro_cancel_confirm_message: 'Il piano Pro resterà attivo fino al {date}. Vuoi continuare?',
  settings_pro_cancel_success_title: 'Annullamento pianificato',
  settings_pro_cancel_success_message: 'Il tuo abbonamento verrà annullato a fine periodo.',
  settings_pro_cancel_failed_message: 'Impossibile annullare l\'abbonamento. Riprova.',
  settings_pro_cancel_manual_title: 'Gestione annullamento esterna',
  settings_pro_cancel_manual_message: 'Per abbonamenti gestiti dagli store (Google Play / App Store) annulla direttamente dal relativo account.',
  settings_push_title: 'Notifiche push',
  settings_push_desc: 'Attiva le notifiche push per ricevere subito match, scambi e recensioni.',
  settings_push_activate_btn: 'Attiva',
  settings_push_activated: 'Notifiche push attivate.',
  settings_push_activate_error: 'Impossibile attivare le notifiche push.',
  settings_push_disabled: 'Notifiche push disattivate.',
  settings_push_permission_denied: 'Permesso notifiche negato dal sistema. Abilitalo nelle impostazioni del dispositivo.',
  settings_clear_collection_title: 'Svuota',
  settings_clear_scope_all: 'Inventario e Wishlist',
  settings_clear_scope_inventory: 'Inventario',
  settings_clear_scope_wishlist: 'Wishlist',
  settings_clear_btn: 'Svuota',
  settings_clear_confirm_title: 'Svuotare {scope}?',
  settings_clear_confirm_message: 'Tutte le carte e i prodotti sealed della sezione verranno eliminati definitivamente. Gli scambi conclusi nello storico resteranno consultabili.',
  settings_clear_confirm_cta: 'Svuota ora',
  settings_clear_success: 'Sezione svuotata correttamente.',
  settings_clear_error: 'Impossibile svuotare la sezione. Riprova più tardi.',
  settings_clear_active_matches: 'Hai ancora match attivi aperti. Chiudi o concludi i match in corso prima di svuotare la sezione.',
  settings_delete_account: 'Elimina account',
  settings_delete_account_desc: 'Cancella definitivamente account e dati associati.',
  settings_delete_account_confirm_title: "Eliminare l'account?",
  settings_delete_account_confirm_message: "L'operazione è irreversibile: profilo, collezione, wishlist, match, chat e recensioni verranno eliminati definitivamente. L'eventuale abbonamento Pro attivo verrà annullato automaticamente su Google Play (senza rimborso del periodo già pagato).",
  settings_delete_account_confirm_cta: 'Elimina definitivamente',
  settings_delete_account_error: "Impossibile eliminare l'account. Riprova più tardi.",
  settings_delete_account_sub_cancel_failed: "Impossibile annullare automaticamente l'abbonamento Pro. Annullalo da Google Play (Pagamenti e abbonamenti → Abbonamenti), poi riprova a eliminare l'account.",
  history_title: 'Storico scambi',
  history_empty: 'Nessuno scambio concluso.',
  history_unavailable_card_label: 'Carta non più disponibile',

  // --- Price info modal ---
  price_info_title: 'Informazioni prezzi',
  price_info_set_price: 'Imposta prezzo',
  price_info_loading: 'Caricamento prezzi...',
  price_info_no_data: 'Nessun dato di prezzo disponibile.',
  price_info_filter_language: 'Lingua',
  price_info_filter_type: 'Tipo',
  price_info_market_prices: 'Prezzi di mercato',
  price_info_estimate_badge: 'stima',
  price_info_market_updating: 'Aggiornamento prezzi di mercato…',
  price_info_no_market_for_language: 'Nessun dato di mercato per questa lingua.',
  price_info_stats_title: 'Statistiche e storico',
  price_info_stats_loading: 'Caricamento statistiche…',
  price_info_history_title: 'Storico prezzi',
  price_info_history_no_points: 'Punti insufficienti per il periodo selezionato.',
  price_info_no_stats: 'Non ci sono statistiche dettagliate per la carta.',
  price_info_graded_title: 'Listini gradati',
  price_info_graded_company: 'Azienda',
  price_info_graded_grade: 'Voto',
  price_info_ebay_title: 'Ultimi venduti eBay',
  price_info_ebay_loading: 'Caricamento venduti eBay...',
  price_info_ebay_empty: 'Nessun venduto eBay disponibile.',
  price_info_variant_normal: 'Holo/Normale',
  price_info_variant_reverse: 'Reverse',
  price_info_label_min: 'Min',
  price_info_label_avg: 'Media',
  price_info_label_trend: 'Trend',
  price_info_label_low: 'Basso',
  price_info_label_market: 'Mercato',
  price_info_label_mid: 'Medio',
  price_info_today: 'Oggi',
  price_info_period_7d: '7g',
  price_info_period_30d: '30g',

  // --- Details modal ---
  details_readonly_info: "La modifica alle quantità può essere effettuata solo dall'utente che ha inviato la proposta e solo in fase di invio dello scambio nella sezione Match",
  details_proposal_sent_info: 'Proposta inviata, le quantità non sono più modificabili.',
  details_offer: 'Offri',
  details_obtain: 'Ottieni',
  details_request: 'Chiedi',
  details_select_all: 'Seleziona tutto',
  details_deselect_all: 'Deseleziona tutto',

  // --- Landing page ---
  landing_header_features: 'Funzionalità',
  landing_header_how_it_works: 'Come funziona',
  landing_header_download: 'Download',
  landing_header_login: 'Accedi',
  landing_hero_badge: 'Disponibile su Android',
  landing_hero_title: 'SwapWish TCG',
  landing_hero_title_accent: 'scambi dal vivo tra collezionisti',
  landing_hero_desc: 'Gestisci collezione, mazzi e wishlist, scansiona le carte con la fotocamera, trova candidati compatibili sulla mappa — anche scambi a tre o con una parte in denaro — e accordati in chat per scambiare di persona.',
  landing_hero_download_btn: 'Scarica per Android',
  landing_hero_ios_btn: 'App Store - Prossimamente',
  landing_hero_slide_inventory: 'Collezione',
  landing_hero_slide_wishlist: 'Wishlist mirata',
  landing_hero_slide_map: 'Mappa scambi',
  landing_hero_slide_filters: 'Filtri attivi',
  landing_hero_slide_candidates: '3 candidati',
  landing_hero_slide_chat: 'Match e chat',
  landing_hero_slide_trade_ready: 'Proposta pronta',
  landing_hero_slide_meet: 'Incontro dal vivo',
  landing_hero_slide_inventory_meta: 'Carte, sealed, varianti',
  landing_hero_slide_wishlist_meta: 'Condizione, lingua, quantità',
  landing_hero_slide_map_tab: 'Mappa',
  landing_hero_slide_your_cards: '2 oggetti',
  landing_hero_slide_their_card: '1 oggetti',
  landing_hero_slide_peer_message: 'Perfetto, ci vediamo sabato?',
  landing_hero_slide_my_message: 'Ottimo! A sabato 👍',
  landing_preview_title: "Uno sguardo dentro l'app",
  landing_preview_subtitle: 'Le viste principali di SwapWish in anteprima, con la collezione Pokémon di esempio di Mario.',
  landing_preview_prev: 'Slide precedente',
  landing_preview_next: 'Slide successiva',
  landing_features_label: 'Funzionalità',
  landing_features_title: 'Dalla collezione e wishlist',
  landing_features_title_accent: 'alla mappa degli scambi',
  landing_features_desc: 'SwapWish TCG organizza le tue carte/prodotti sealed, mostra chi è compatibile vicino a te e ti aiuta a concludere lo scambio in modo chiaro.',
  landing_feature_swipe_title: 'Collezione, mazzi e scanner',
  landing_feature_swipe_desc: 'Aggiungi carte e sealed cercandoli nel catalogo o scansionandoli con la fotocamera (anche import in blocco da CardTrader, Cardmarket o TCGplayer), organizza i mazzi e consulta i prezzi di mercato aggiornati.',
  landing_feature_nearby_title: 'Mappa, classifica e candidati',
  landing_feature_nearby_desc: 'Visualizza gli utenti compatibili — anche chi ha una carta che cerchi da regolare in denaro — applica filtri e raggio, e consulta la LeaderBoard scambi con storico, collezione e recensioni dei collezionisti vicini.',
  landing_feature_realtime_title: 'Match, chat e notifiche',
  landing_feature_realtime_desc: 'Avvia una proposta, segui lo stato del match, ricevi una notifica quando un nuovo collezionista compatibile entra nel tuo raggio e accordati in chat su luogo e dettagli.',
  landing_feature_multi_title: 'Pro: multi-TCG, scambi a tre e raggio esteso',
  landing_feature_multi_desc: 'Estendi la ricerca a più giochi e fino a 500 km, sblocca slot illimitati e scopri gli scambi a tre — anche quando una gamba si salda in denaro invece che con le carte.',
  landing_how_label: 'Come funziona',
  landing_how_title: 'Tre passi',
  landing_how_title_accent: 'per lo scambio perfetto',
  landing_how_add_title: 'Carica inventario e wishlist',
  landing_how_add_desc: 'Cerca nel catalogo o scansiona le carte con la fotocamera, indica quantità, condizione e lingua, e controlla i prezzi di mercato prima di proporre.',
  landing_how_find_title: 'Filtra la mappa e apri i candidati',
  landing_how_find_desc: 'Scegli raggio, giochi e prodotti: SwapWish mostra i profili compatibili e le proposte disponibili.',
  landing_how_close_title: 'Proponi, chatta e incontrati',
  landing_how_close_desc: 'Confermate lo scambio, accordatevi in chat e completate la consegna di persona.',
  landing_download_label: 'Download',
  landing_download_title: 'Inizia a scambiare',
  landing_download_title_accent: 'oggi stesso',
  landing_download_desc: 'Scarica l\'app gratuitamente, crea il tuo binder e inizia a trovare scambi vicino a te.',
  landing_download_android_req: 'Android 8.0+',
  landing_download_android_status: 'Disponibile',
  landing_download_android_desc: 'Installa il file APK direttamente, senza bisogno del Play Store. Aggiornamenti automatici in-app.',
  landing_download_android_btn: 'Scarica app',
  landing_download_free: 'Gratis',
  landing_download_no_ads: 'Senza pubblicità',
  landing_download_updates: 'Aggiornamenti gratuiti',
  landing_download_ios_req: 'iOS 16+',
  landing_download_ios_status: 'Prossimamente',
  landing_download_ios_desc: 'La versione iOS è in sviluppo attivo. Iscriviti alla lista d\'attesa per essere il primo a provarla.',
  landing_download_ios_hint: 'Vuoi essere avvisato?',
  landing_download_ios_contact: 'Contattaci',
  landing_modal_aria: 'Download SwapWish TCG',
  landing_modal_close: 'Chiudi',
  landing_modal_title: 'Download per Android',
  landing_modal_subtitle: 'File APK · Aggiornamenti in-app',
  landing_modal_download_btn: 'Scarica APK',
  landing_modal_downloading: 'Download in corso...',
  landing_modal_downloaded: 'Download completato',
  landing_modal_download_error: 'Download non riuscito. Verifica che il file APK sia pubblicato correttamente e riprova.',
  landing_modal_how_to_install: 'Come installare',
  landing_modal_step1_title: 'Apri il file scaricato',
  landing_modal_step1_desc: 'Trova il file APK nella cartella Download del tuo dispositivo.',
  landing_modal_step2_title: 'Consenti origini sconosciute',
  landing_modal_step2_desc: 'Nelle impostazioni, abilita <em>"Installa app da fonti sconosciute"</em>.',
  landing_modal_step3_title: 'Installa l\'app',
  landing_modal_step3_desc: 'Segui le istruzioni di installazione sullo schermo.',
  landing_modal_step4_title: 'Aprila e registrati',
  landing_modal_step4_desc: 'Crea il tuo account e inizia a cercare scambi vicino a te.',
  landing_modal_safety: 'File sicuro, verificato dal team SwapWish.',
  landing_footer_tagline: 'La piattaforma di scambio carte TCG per collezionisti.',
  landing_footer_nav_aria: 'Navigazione footer',
  landing_footer_app_section: 'App',
  landing_footer_features: 'Funzionalità',
  landing_footer_how_it_works: 'Come funziona',
  landing_footer_download_android: 'Scarica per Android',
  landing_footer_support_section: 'Supporto',
  landing_footer_contact: 'Contattaci',
  landing_footer_webapp: 'Accedi alla Web App',
  landing_footer_legal_section: 'Legale',
  landing_footer_privacy: 'Privacy Policy',
  landing_footer_terms: 'Termini di servizio',
  landing_footer_delete_account: 'Elimina account',
  landing_footer_child_safety: 'Tutela dei minori',
  landing_footer_copyright: '© {year} SwapWish TCG. Tutti i diritti riservati.',
  landing_footer_made: 'Fatto con ♥ per i collezionisti',

  // --- Product type tabs (Inventory / Wishlist / Catalog) ---
  tab_type_cards: 'Carte',
  tab_type_sealed: 'Sealed',
  sealed_no_year: 'Anno sconosciuto',
  sealed_empty_desc: 'Aggiungi prodotti sealed per vederli qui.',
  cards_empty_desc: 'Aggiungi carte per vederle qui.',

  // --- Filtro lingua a tab (Collezione / Wishlist / Catalogo) ---
  lang_tab_global: 'Occidentale',
  lang_tab_asia: 'Orientale',
  lang_tab_english: 'Inglese',

  // --- Griglia espansioni + vista espansione ---
  expansion_search_placeholder: 'Cerca espansione',
  viewing_language_label: 'Stai visualizzando in lingua:',
  grid_cols_toggle_label: 'Colonne griglia',
  grid_cols_2: 'Mostra 2 per riga',
  grid_cols_4: 'Mostra 4 per riga',
  card_scan_button_label: 'Scansiona una carta',
  card_scan_title: 'Scansione carta',
  card_scan_free_limit: 'Free: {limit} scansioni/giorno · Rimaste: {remaining}',
  card_scan_pro_unlimited: 'PRO: scansioni illimitate',
  card_scan_starting: 'Avvio fotocamera…',
  card_scan_scanning: 'Inquadra la carta nel riquadro: nome e numero ben leggibili',
  card_scan_results_title: 'È una di queste?',
  card_scan_limit_reached: 'Hai esaurito le scansioni gratuite di oggi. Passa a PRO per scansioni illimitate.',
  card_scan_camera_error: 'Fotocamera non disponibile o permesso negato.',
  card_scan_permission_denied: 'Serve il permesso fotocamera per scansionare le carte. Concedilo per continuare.',
  card_scan_permission_blocked: 'Permesso fotocamera negato. Abilitalo dalle impostazioni dell\'app per scansionare le carte.',
  card_scan_open_settings: 'Apri impostazioni',
  card_scan_camera_timeout: 'Avvio fotocamera non riuscito (tempo scaduto). Controlla i permessi e riprova.',
  card_scan_grant_permission: 'Concedi permesso',
  card_scan_error: 'Scansione non riuscita. Riprova.',
  card_scan_cards_only: 'Funziona solo con le carte singole, non con i prodotti sealed.',
  card_scan_game_hint: 'Stai scansionando {game}',
  card_scan_resume: 'Riprendi scansione',
  card_scan_not_found: 'Carta non trovata',
  card_scan_retry: 'Riprova',
  card_scan_alternatives: 'Altre corrispondenze',
  card_scan_choose_type: 'Cosa vuoi scansionare?',
  card_scan_choose_type_help: 'Scegli il riconoscimento della carta oppure il certificato di una carta gradata.',
  card_scan_type_raw: 'Carta',
  card_scan_type_raw_help: 'Riconosci una carta non gradata da immagine e testo.',
  card_scan_type_graded: 'Carta gradata',
  card_scan_type_graded_help: 'Leggi il QR o inserisci il certificato dello slab.',
  graded_scan_title: 'Carta gradata',
  graded_scan_choose_provider: 'Scegli la casa di gradazione',
  graded_scan_provider_help: 'Il provider rilevato dal QR sarà confrontato con quello scelto.',
  graded_scan_automatic: 'Automatico',
  graded_scan_assisted: 'Assistito',
  graded_scan_manual_badge: 'Manuale',
  graded_scan_scan_qr: 'Scansiona QR',
  graded_scan_enter_cert: 'Inserisci certificato',
  graded_scan_cert_number: 'Numero di certificato',
  graded_scan_continue: 'Continua',
  graded_scan_scanning_qr: 'Inquadra il QR dello slab',
  graded_scan_camera_unavailable: 'Fotocamera non disponibile. Puoi inserire il certificato manualmente.',
  graded_scan_qr_decoder_unavailable: 'Il decoder QR nativo non è disponibile su questo dispositivo. Usa il numero di certificato.',
  graded_scan_empty: 'Inserisci un certificato.',
  graded_scan_unsupported_qr: 'QR non riconosciuto: sono accettati solo URL HTTPS ufficiali dei grader supportati.',
  graded_scan_invalid_cert_number: 'Numero di certificato non valido.',
  graded_scan_provider_conflict_title: 'Il grader non coincide',
  graded_scan_provider_conflict: 'Hai scelto {selected}, ma il QR sembra appartenere a {detected}. Conferma quale usare.',
  graded_scan_use_detected: 'Usa {provider}',
  graded_scan_keep_selected: 'Mantieni {provider}',
  graded_scan_lookup: 'Verifica del certificato…',
  graded_scan_matching: 'Ricerca nel catalogo…',
  graded_scan_ambiguous_title: 'Scegli la carta corretta',
  graded_scan_ambiguous_help: 'I dati del certificato corrispondono a più carte. Controlla set, numero e anno.',
  graded_scan_match_score: 'Corrispondenza {score}%',
  graded_scan_search_catalog: 'Cerca nel catalogo',
  graded_scan_assisted_title: 'Verifica assistita',
  graded_scan_assisted_help: 'Apri il sito ufficiale, verifica il certificato e completa voto e carta senza uscire dal flusso.',
  graded_scan_verify_official: 'Verifica sul sito ufficiale',
  graded_scan_manual_verified_confirm: 'Confermo di aver verificato questo certificato sul sito ufficiale del grader.',
  graded_scan_manual_unverified_confirm: 'Comprendo che questo certificato non può essere verificato automaticamente e confermo i dati inseriti.',
  graded_scan_grade: 'Voto',
  graded_scan_already_imported: 'Certificato già aggiunto',
  graded_scan_duplicate_help: 'La copia esistente è stata mantenuta: la quantità non è stata incrementata.',
  graded_scan_another: 'Scansiona un’altra carta',
  graded_scan_cert_verified: 'Certificato trovato',
  graded_scan_assisted_result: 'Dati da confermare',
  graded_scan_authenticity_disclaimer: 'La verifica del record non dimostra l’autenticità fisica dello slab.',
  graded_scan_subject: 'Soggetto',
  graded_scan_provider_status: 'Stato provider',
  graded_scan_year: 'Anno',
  graded_scan_variety: 'Varietà',
  graded_scan_language_confirm: 'Lingua della carta',
  graded_scan_choose_language: 'Conferma la lingua',
  graded_scan_variant_confirm: 'Variante',
  graded_scan_choose_variant: 'Conferma la variante',
  graded_scan_no_variant: 'Nessuna variante',
  graded_scan_unsupported_grade: 'Il voto del provider non è rappresentabile: non verrà arrotondato.',
  graded_scan_add_inventory: 'Aggiungi all’inventario',
  graded_scan_choose_another: 'Scegli un’altra carta',
  graded_scan_added: 'Carta aggiunta',
  graded_scan_added_help: 'Una copia è stata aggiunta con una ricevuta annullabile.',
  graded_scan_undo_done: 'Aggiunta annullata.',
  graded_scan_error_title: 'Verifica non riuscita',
  graded_scan_manual_fallback: 'Passa al flusso manuale',
  graded_scan_game_required: 'Seleziona prima un gioco nell’inventario.',
  graded_scan_error_unauthorized: 'Sessione non valida. Accedi di nuovo.',
  graded_scan_error_invalid_request: 'Dati incompleti o non validi.',
  graded_scan_error_invalid_provider: 'Grader non supportato.',
  graded_scan_error_invalid_cert_number: 'Numero di certificato non valido.',
  graded_scan_error_provider_conflict: 'Il grader scelto non coincide con il QR.',
  graded_scan_error_provider_not_configured: 'La verifica automatica del provider non è ancora configurata.',
  graded_scan_error_provider_unavailable: 'Il servizio ufficiale non è disponibile. Riprova più tardi.',
  graded_scan_error_provider_rate_limited: 'Limite del provider raggiunto. Riprova più tardi.',
  graded_scan_error_provider_record_inactive: 'Il record del certificato risulta inattivo, revocato o non valido.',
  graded_scan_error_cert_not_found: 'Certificato non trovato nel database ufficiale.',
  graded_scan_error_unsupported_grade: 'Voto non supportato.',
  graded_scan_error_catalog_match_ambiguous: 'Corrispondenza catalogo ambigua.',
  graded_scan_error_catalog_match_not_found: 'Carta non trovata nel gioco selezionato.',
  graded_scan_error_language_required: 'Conferma una lingua valida.',
  graded_scan_error_variant_required: 'Conferma una variante valida.',
  graded_scan_error_duplicate_cert: 'Certificato già presente.',
  graded_scan_error_slot_limit_reached: 'Limite slot raggiunto.',
  graded_scan_error_protected_quantity: 'Questa copia è impegnata in un match attivo e non può essere rimossa.',
  graded_scan_error_import_not_found: 'Ricevuta di importazione non trovata.',
  graded_scan_error_lookup_expired: 'La verifica è scaduta. Eseguila di nuovo.',
  graded_scan_lookup_again: 'Ripeti verifica',
  graded_scan_error_scan_limit_reached: 'Hai esaurito le scansioni disponibili oggi.',
  graded_scan_error_internal_error: 'Errore inatteso. Riprova.',
  expansion_card_count: '{count} carte',
  expansion_product_count: '{count} prodotti',
  set_card_badge_cards: '{count} carte',
  set_card_badge_sealed: '{count} sealed',
  expansion_back: 'Espansioni',
  sets_empty_title: 'Nessuna espansione',
  sets_empty_desc: 'Nessuna espansione disponibile per i filtri selezionati.',
  expansion_kind_main: 'Principali',
  expansion_kind_promo: 'Promo',
  expansion_kind_extra: 'Promo e Extra',
  expansion_kind_deck: 'Mazzi',
  expansion_count_label: 'Espansioni: {count}',
  inventory_photos_title: 'Foto allegate',
  inventory_photo_view: 'Visualizza le foto allegate',
  inventory_photo_alt: "Foto allegata dell'oggetto",
  inventory_photo_add: 'Aggiungi foto',
  inventory_photo_delete: 'Elimina foto',
  inventory_photo_expand: 'Ingrandisci foto',
  inventory_photo_collapse: 'Riduci foto',
  inventory_photo_edit_mode_hint: 'Per aggiungere o rimuovere foto, entra nella modalità modifica della carta.',
  inventory_photo_empty: 'Nessuna foto allegata.',
  media_load_error: 'Impossibile caricare le foto allegate.',
  media_upload_error: 'Impossibile caricare il file.',
  media_delete_error: 'Impossibile eliminare la foto.',
  media_blocked_error: 'Caricamento bloccato: il contenuto potrebbe essere inappropriato, esplicito o illegale.',
  moderation_unavailable_error: 'Il controllo di sicurezza non è disponibile. Il caricamento è stato bloccato; riprova più tardi.',
  media_invalid_error: "Non è possibile controllare in sicurezza l'immagine o il video selezionato.",

  // ── Funzionalità verificate: verifica profilo, tornei, banner ──────────────
  profile_request_verification: 'Richiedi verifica',
  profile_verified_features: 'Funzionalità verificate',
  profile_manage_banners: 'Gestisci banner',
  profile_manage_verifications: 'Gestisci verifiche',

  verify_title: 'Richiedi verifica',
  verify_subtitle: 'Diventa un profilo verificato (negozio, associazione o altro.) per creare tornei visibili nella mappa e mostrare un banner sulla mappa per sponsorizzare la tua attività agli utenti della tua città.',
  verify_activity_type: 'Tipo di attività',
  verify_activity_shop: 'Negozio',
  verify_activity_association: 'Associazione',
  verify_activity_organizer: 'Organizzatore',
  verify_activity_other: 'Altro',
  verify_activity_name: 'Nome attività',
  verify_vat: 'Partita IVA / Codice fiscale',
  verified_badge_label: 'Profilo verificato',
  verify_cf: 'Codice Fiscale',
  verify_piva: 'Partita IVA',
  verify_need_cf: 'Inserisci il Codice Fiscale',
  verify_invalid_cf: 'Codice Fiscale non valido',
  verify_need_piva: 'Inserisci la Partita IVA',
  verify_invalid_piva: 'Partita IVA non valida',
  // Utenti fuori dall'Italia: campo unico generico al posto di CF+P.IVA.
  verify_business_id: 'Numero identificativo attività',
  verify_need_business_id: 'Inserisci il numero identificativo dell\'attività',
  verify_need_first_last: 'Inserisci nome e cognome',
  verify_proofs_hint: "Allega fronte e retro della carta d'identità o del passaporto.",
  verify_contact_note: 'Note (facoltative)',
  verify_add_proof: 'Aggiungi documento',
  verify_submit: 'Invia richiesta',
  verify_pending_title: 'Richiesta in attesa',
  verify_pending_desc: 'La tua richiesta di verifica è in fase di revisione.',
  verify_submitted: 'Richiesta inviata',
  verify_error: 'Impossibile inviare la richiesta',
  verify_need_name: 'Inserisci il nome dell’attività',
  verify_need_proof: 'Allega fronte e retro del documento (almeno 2 file)',

  vf_title: 'Funzionalità verificate',
  vf_configure_banner: 'Configura banner',
  vf_configure_banner_desc: 'Crea un banner brandizzato per la tua città.',
  vf_manage_tournaments: 'Gestisci Tornei',
  vf_manage_tournaments_desc: 'Crea e gestisci il tuo torneo e i partecipanti.',

  // ── Tornei ─────────────────────────────────────────────────────────────────
  tourn_button: 'Tornei',
  tourn_list_title: 'Tornei',
  tourn_list_eyebrow: 'Vicino a te',
  tourn_empty_title: 'Nessun torneo nelle vicinanze',
  tourn_empty_desc: 'Al momento non ci sono tornei nel raggio di ricerca.',
  tourn_participants_count: '{count} partecipanti',
  tourn_participants_list: 'Lista partecipanti',
  tourn_entry_fee: 'Quota di iscrizione',
  tourn_free_entry: 'Gratuito',
  tourn_date: 'Data',
  tourn_time: 'Ora',
  tourn_location: 'Luogo',
  tourn_organizer: 'Organizzatore',
  tourn_contact_phone: 'Telefono',
  tourn_contact_email: 'Email',
  tourn_description: 'Descrizione',
  tourn_request_participation: 'Richiedi partecipazione',
  tourn_participation_pending: 'Richiesta inviata',
  tourn_participation_accepted: 'Partecipazione confermata',
  tourn_participation_rejected: 'Richiesta rifiutata',
  tourn_view_profile: 'Vedi profilo',
  tourn_request_title: 'Richiedi partecipazione',
  tourn_request_first_name: 'Nome',
  tourn_request_last_name: 'Cognome',
  tourn_request_phone: 'Numero di telefono',
  tourn_request_send: 'Invia richiesta',
  tourn_request_error: 'Impossibile inviare la richiesta',
  tourn_request_need_fields: 'Compila nome, cognome e telefono',
  // ── Tornei: solo su invito / link di invito ──
  tourn_invite_only: 'Solo su invito',
  tourn_invite_only_hint: 'Il torneo non comparirà sulla mappa: condividi il link di invito per far partecipare chi vuoi.',
  tourn_invite_badge: 'Solo su invito',
  tourn_invite_link_label: 'Link di invito',
  tourn_invite_copy: 'Copia',
  tourn_invite_copied: 'Copiato!',
  tourn_invite_share: 'Condividi',
  tourn_invite_share_text: 'Partecipa al torneo "{name}" su SwapWish!',
  tourn_invite_join_title: 'Partecipa al torneo',
  tourn_invite_join_send: 'Partecipa',
  tourn_participants_title: 'Partecipanti',
  tourn_no_participants: 'Nessun partecipante',
  tourn_participant_accept: 'Accetta',
  tourn_participant_reject: 'Rifiuta',
  tourn_pending_badge: 'In attesa',
  tourn_accepted_badge: 'Accettato',
  tourn_rejected_badge: 'Rifiutato',

  tourn_create: 'Crea Torneo',
  tourn_create_title: 'Crea Torneo',
  tourn_name: 'Nome torneo',
  tourn_game: 'Tipo di gioco',
  tourn_game_placeholder: 'Seleziona gioco',
  tourn_max_short: 'Max part.',
  tourn_max_participants: 'N. massimo partecipanti',
  tourn_image: 'Immagine',
  tourn_add_image: 'Aggiungi immagine',
  tourn_location_hint: 'Inserisci il luogo del torneo',
  tourn_create_submit: 'Crea torneo',
  tourn_create_short: 'Crea torneo',
  tourn_created: 'Torneo creato',
  tourn_create_error: 'Impossibile creare il torneo',
  tourn_create_need_fields: 'Compila nome, data e luogo',
  tourn_cancel: 'Annulla torneo',
  tourn_cancel_confirm: 'Vuoi annullare il torneo?',
  tourn_cancelled: 'Torneo annullato',
  tourn_manage_title: 'Gestisci Tornei',
  tourn_no_active: 'Non hai tornei attivi',
  tourn_one_active_hint: 'Puoi avere un solo torneo attivo alla volta.',
  tourn_max_active_hint: 'Puoi avere fino a 5 tornei attivi contemporaneamente.',
  tourn_active_counter: '{count}/{max} tornei attivi',
  tourn_requests: 'Richieste di partecipazione',
  tourn_history_title: 'Storico tornei',
  tourn_history_empty: 'Nessun torneo concluso',
  tourn_history_empty_hint: 'I tornei conclusi con "Concludi" appariranno qui con il vincitore.',
  tourn_delete: 'Elimina',
  tourn_delete_confirm_title: 'Elimina torneo',
  tourn_delete_confirm_msg: 'Il torneo "{name}" verrà rimosso definitivamente e NON comparirà nello storico. Continuare?',
  tourn_delete_error: 'Impossibile eliminare il torneo',
  tourn_complete: 'Concludi',
  tourn_complete_short: 'Concludi',
  tourn_complete_title: 'Concludi torneo',
  tourn_complete_pick_winner: 'Seleziona il vincitore del torneo tra i partecipanti accettati: il torneo verrà spostato nello storico.',
  tourn_complete_need_winner: 'Seleziona un vincitore',
  tourn_complete_no_participants: 'Nessun partecipante accettato: accetta almeno un partecipante per poter concludere il torneo.',
  tourn_complete_error: 'Impossibile concludere il torneo',
  tourn_winner: 'Vincitore',
  // ── Tornei: modifica/duplica/promemoria/vittorie ──
  tourn_edit: 'Modifica',
  tourn_edit_title: 'Modifica torneo',
  tourn_edit_hint: 'Puoi modificare nome, descrizione, ora, immagine e contatti. Data, luogo, quota e numero massimo di partecipanti non sono modificabili: i partecipanti hanno aderito a quelle condizioni.',
  tourn_duplicate: 'Duplica',
  notif_tournament_reminder: 'Promemoria: domani si tiene un torneo a cui partecipi',
  leaderboard_tournament_wins: '{count} tornei vinti',
  // ── Banner: coda, metriche, pagamento fuori Android ──
  banner_queue_position: 'Sei {position}º in coda per questa città.',
  banner_stat_impressions: 'Visualizzazioni',
  banner_stat_clicks: 'Click',
  banner_pay_open_android: 'Il pagamento si completa dall’app Android: apri SwapWish sul tuo dispositivo Android e torna in "Configura banner" per pagare. Supporto iOS in arrivo.',
  // ── Tour guidato: tornei e funzionalità verificate ──
  tour_profile_verified_title: 'Sei un negozio o un’associazione?',
  tour_profile_verified_text: 'Dal Profilo puoi richiedere la verifica: una volta verificato potrai creare tornei sulla mappa e prenotare banner brandizzati per la tua città.',
  // ── What's new (one-shot per versione) ──
  whats_new_eyebrow: 'Novità',
  whats_new_title: 'Cosa c’è di nuovo su SwapWish',
  whats_new_tournaments_title: 'Tornei sulla mappa',
  whats_new_tournaments_text: 'Negozi e associazioni verificate organizzano tornei vicino a te: guardali sulla mappa e richiedi di partecipare.',
  whats_new_banner_title: 'Banner della tua città',
  whats_new_banner_text: 'I profili verificati possono prenotare un banner brandizzato visibile sulla mappa agli utenti della propria città.',
  whats_new_chat_title: 'Chat migliorata',
  whats_new_chat_text: 'Spunte di lettura, "sta scrivendo…", reinvio dei messaggi non partiti e proposta di scambio direttamente dalla chat.',
  whats_new_cta: 'Iniziamo',
  // ── I miei tornei (partecipante) ──
  profile_my_tournaments: 'I miei tornei',
  mytourn_title: 'I miei tornei',
  mytourn_history_title: 'Storico partecipazioni',
  mytourn_empty: 'Nessuna iscrizione attiva',
  mytourn_empty_hint: 'Le richieste di partecipazione ai tornei sulla mappa appariranno qui con il loro stato.',
  mytourn_history_empty: 'Nessun torneo concluso',
  mytourn_history_empty_hint: 'I tornei conclusi a cui hai partecipato appariranno qui, con le tue vittorie.',
  mytourn_won_badge: 'Vittoria',
  // ── I miei tornei: partecipa tramite link di invito ──
  mytourn_invite_prompt: 'Hai un link di invito a un torneo?',
  mytourn_invite_placeholder: 'Incolla qui il link di invito',
  mytourn_invite_search: 'Cerca',
  mytourn_invite_invalid: 'Link di invito non valido o torneo non più disponibile.',
  mytourn_invite_is_creator: 'Questo è un tuo torneo: gestiscilo dalla Gestione Tornei.',
  mytourn_invite_already: 'Sei già iscritto a questo torneo.',
  mytourn_invite_full: 'Il torneo ha raggiunto il numero massimo di partecipanti.',
  // ── Vetrina profilo pubblico ──
  profile_showcase: 'Vetrina profilo',
  profile_showcase_products: 'Vetrina',
  showcase_title: 'Vetrina profilo',
  showcase_desc: 'Scegli fino a 5 carte/prodotti sealed che hai nell’inventario e 5 che hai nella wishlist: appariranno in evidenza in cima al tuo profilo pubblico condiviso.',
  showcase_offer_section: 'Inventario in evidenza',
  showcase_seek_section: 'Wishlist in evidenza',
  showcase_offer_empty: 'Nessun oggetto cedibile nell’inventario.',
  showcase_seek_empty: 'La wishlist è vuota.',
  showcase_saved: 'Vetrina aggiornata.',
  showcase_add: 'Aggiungi',
  showcase_pick_offer_title: 'Aggiungi dall’Inventario',
  showcase_pick_seek_title: 'Aggiungi dalla Wishlist',
  showcase_none_selected: 'Nessuna carta in evidenza. Cercala qui sotto e selezionala per aggiungerla alla vetrina.',
  showcase_added_section: 'Aggiunte in vetrina',
  showcase_search_placeholder: 'Cerca una carta o un prodotto sealed',
  showcase_no_results: 'Nessun risultato',
  showcase_remove: 'Rimuovi',
  showcase_done: 'Fatto',
  shared_showcase_title: 'In evidenza',
  shared_showcase_offer: 'Offro',
  shared_showcase_seek: 'Cerco',

  tourn_completed_badge: 'Concluso',

  // ── Banner città ───────────────────────────────────────────────────────────
  banner_config_title: 'Configura banner',
  banner_price_badge: 'A solo 4,99',
  banner_config_desc: 'Il banner sarà visibile per 7 giorni solo agli utenti della tua stessa città, in basso sulla mappa. Sarà visibile a partire dal momento in cui viene completato il pagamento.',
  banner_city_label: 'Città',
  banner_no_city: 'Imposta un indirizzo con la città per creare un banner.',
  banner_text_label: 'Testo brandizzato',
  banner_url_label: 'URL esterno',
  banner_book: 'Prenota Banner',
  banner_pending_approval: 'In attesa di conferma',
  banner_pay: 'Paga Banner',
  banner_pay_price: 'Paga banner (4,99 €)',
  banner_approved_notice: 'Banner approvato: completa il pagamento per pubblicarlo.',
  banner_slot_occupied: 'Un altro banner è già attivo per la tua città.',
  banner_slot_countdown: 'Potrai completare l’acquisto tra {time}.',
  banner_active_notice: 'Banner attivo',
  banner_active_until: 'Attivo fino al {date}',
  banner_rejected_notice: 'Banner non approvato',
  banner_created: 'Banner prenotato',
  banner_create_error: 'Impossibile prenotare il banner',
  banner_monthly_limit: 'Hai già prenotato un banner questo mese.',
  banner_monthly_limit_countdown: 'Potrai prenotarne un altro tra {time}.',
  banner_pay_error: 'Pagamento non riuscito',
  banner_pay_mobile_only: 'Il pagamento è disponibile solo dall’app Android.',
  banner_paid_ok: 'Pagamento completato',

  admin_banners_title: 'Gestisci banner',
  admin_banner_sent_at: 'Prenotato il',
  admin_banners_pending: 'In attesa di approvazione',
  admin_banners_active: 'Attivi',
  admin_approve: 'Approva',
  admin_reject: 'Rifiuta',
  admin_no_banners: 'Nessun banner',
  admin_verifications_title: 'Gestisci verifiche',
  admin_no_verifications: 'Nessuna richiesta',
  admin_view_proofs: 'Vedi documenti',
  admin_decided_ok: 'Operazione completata',

  notif_tournament_created: 'Nuovo torneo vicino a te',
  notif_tournament_join_request: 'Nuova richiesta di partecipazione al tuo torneo',
  notif_tournament_join_accepted: 'La tua partecipazione al torneo è stata accettata',
  notif_tournament_join_rejected: 'La tua partecipazione al torneo è stata rifiutata',
  notif_tournament_deleted: 'Un torneo a cui partecipavi è stato annullato',
  notif_tournament_completed: 'Un torneo a cui hai partecipato si è concluso',
  notif_tournament_won: 'Hai vinto il torneo! 🏆',
  notif_verification_approved: 'Profilo verificato: ora puoi creare tornei e banner',
  notif_verification_rejected: 'Richiesta di verifica non approvata',
  notif_banner_approved: 'Banner approvato: completa il pagamento',
  notif_banner_rejected: 'Banner non approvato',
  notif_admin_verification_request: 'Nuova richiesta di verifica ricevuta',
  notif_admin_banner_request: 'Nuova richiesta di banner ricevuta',
  admin_history_title: 'Storico richieste',
  admin_tab_pending: 'In attesa',
  admin_tab_history: 'Storico',

  // Guida + landing: tornei ed eventi
  help_section_tournaments_desc: 'Negozi e associazioni verificati possono creare tornei ed eventi, visibili sulla mappa e nella lista Tornei.',
  help_section_tournaments_b1: 'Richiedi la verifica dal profilo per diventare un organizzatore.',
  help_section_tournaments_b2: 'Crea un torneo con data, luogo, quota e numero di partecipanti.',
  help_section_tournaments_b3: 'Gli utenti vicini ricevono una notifica e possono richiedere di partecipare.',
  help_section_tournaments_b4: 'Accetta o rifiuta le richieste e gestisci la lista partecipanti.',
  help_tournaments_title: 'Tornei ed eventi',
  landing_feature_tournaments_title: 'Tornei ed eventi',
  landing_feature_tournaments_desc: 'Negozi e associazioni verificati organizzano tornei ed eventi geolocalizzati: trovali sulla mappa e partecipa.',

  // ── Collezione: valore, CSV, selezione multipla ──
  bulk_select_toggle: 'Selezione multipla',
  bulk_select_item: 'Seleziona prodotto',
  bulk_selected_count: '{count} selezionati',
  bulk_delete: 'Elimina',
  bulk_move_to_wishlist: 'Sposta in Wishlist',
  bulk_move_to_inventory: 'Sposta in Inventario',
  bulk_delete_confirm_title: 'Eliminare i prodotti selezionati?',
  bulk_delete_confirm_message: '{count} prodotti verranno rimossi dalla collezione.',
  bulk_deleted_flash: 'Eliminati {count} prodotti',
  bulk_moved_flash: 'Spostati {count} prodotti',
  bulk_locked_item: 'Prodotto impegnato in un match attivo: non selezionabile',
} as const;


